var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProdAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-3",
    cx: 249.53,
    cy: 325.18,
    rx: 235.12,
    ry: 135.74,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.22,348.88l34.29-19.8-.5-.86L56,347.88H40.87l-19.1,11c.13.3.26.61.4.92l19-10.95Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.41,368.42l-.5-.87-23,13.26H35l.78,1h7.42Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,341.82,90,341,30.84,375.09c.19.28.37.56.56.83Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.61,226.68l55.05-31.78-1.56-.26-54,31.17Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.05,192.35l-1.65-.19-12.23,7.06.5.86Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,207.44l-16.84,9.72a5.17,5.17,0,0,0-3.14.13l-23.36-13.48-1.32.39,23.74,13.7a1.16,1.16,0,0,0-.06,1.66L152.9,227.4l21.72,12.54.5-.86L154.9,227.4l12.49-7.21a5,5,0,0,0,3.36.14l18.92,10.92.5-.86-18.36-10.6a1.23,1.23,0,0,0-.08-2.1l17.74-10.25-17.93-10.35-1.46.31Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58,206V191.13l-1,.09v14.17l-24.15,14a4.92,4.92,0,0,0-3.83.25,1.34,1.34,0,0,0,0,2.54,4.87,4.87,0,0,0,4.4,0c1-.61,1.18-1.53.43-2.22l23.9-13.8Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,395.84l.75-.72L438.75,388V372.61L331.56,310.72l-.44-.76-.44.25-.44-.25-.11-.07H305.69l25-14.43,137.65,79.48.56-.83L332.4,295.3c4.24-.15,15.21,0,22.43.2H355l1.68-1,118.69,68.52c.15-.3.3-.6.44-.9L357.65,294l8.64-5,1.62.94h0l.08.05,0,0h0L450,337.09c-.73.69-.59,1.6.45,2.2a4.85,4.85,0,0,0,4.39,0,1.34,1.34,0,0,0,0-2.54,4.93,4.93,0,0,0-3.85-.24L370,290h23.33l0,.07.12-.07h13.35l68,39.23v22.19l4.48,2.59c.12-.32.23-.64.34-1l-3.82-2.21V328.63l-25-14.45,4.1-2.36V300.65l21-12.13c-.14-.3-.29-.6-.44-.9l-21.32,12.31-.25.14v11.17l-4.1,2.37L431.41,303v-8.47L449,284.38l.25-.15V267.89l9.06-5.24-.68-.76L408.92,290l-1.65-.95-.12-.07H395.26l56.8-32.79-.75-.72L393.26,289h-25l-1-.58L398,270.69l-.5-.87-31.16,18-15.46-8.92h1.3l42.09-24.31h19.71a1.89,1.89,0,0,0,.77.77,4.87,4.87,0,0,0,4.4,0c1-.6,1.18-1.52.43-2.21l17.33-10-.86-.66-17.47,10.08a4.93,4.93,0,0,0-3.83.25,2,2,0,0,0-.77.77H394l-42.1,24.31H349.1l-17.42-10.06,48.4-27.94h28.7l12.65-7.31-1-.59-12,6.9h-28.7l-49.14,28.36L316,258.79l61-35.2a5,5,0,0,0,3.36,0l16.06,9.27,12.68-7.32-1-.55-11.64,6.72L381.33,223a1.18,1.18,0,0,0-.05-1.83l8.49-4.9-1.14-.5-8.35,4.82a5.23,5.23,0,0,0-3.18,0l-17-9.84,5.94-3.43c-.42-.14-.84-.29-1.27-.42l-5.67,3.27-7.33-4.23c.68-.68.52-1.57-.49-2.15a4.81,4.81,0,0,0-4.4,0c-1,.6-1.18,1.52-.43,2.21l-61,35.2L281.67,239l-.12-.06H261.48l33.14-19.14h15.09l33.22-19.18-1.41-.34-32.08,18.52H294.35l-34.28,19.8.19.34h-7.41l-18-10.42,33.43-19.3.25-.14V189.89l-1,0v18.61l-33.68,19.44-3.1-1.79-.5.87,2.6,1.5L217,237.63l-3.11-1.8-.5.87,2.61,1.5-17.09,9.87-.25.14v.64L195,246.74l-.5.86,4.16,2.41v8.91l-8.56-5-.5.87,9.06,5.23v1.24l-14.11,8.15-12.74-7.36-.5.86L183.51,270l-14,8.11-12.75-7.35-.5.86,12.25,7.07-60.19,34.75H85.73L45,337V322L246.81,205.51l.25-.14V189.46h-1v15.33L88.33,295.86H57L14.58,320.37c0,.4-.06.8-.08,1.2l42.81-24.71H86.6L44.25,321.31l-.25.14v16.12L19,352l.34,1L86,314.47h22.55l60.92-35.17,7,4-16.86,9.74a4.92,4.92,0,0,0-4,.17,1.34,1.34,0,0,0,0,2.54,5,5,0,0,0,3.84.25l4.2,2.43-12.38,7.15-.25.14v13.1L82.34,358.46l-.25.14v19.31l-15.45,8.92a4.92,4.92,0,0,0-3.83.25,1.89,1.89,0,0,0-.77.77H40.91c.3.33.6.67.91,1H62a1.45,1.45,0,0,0,.33.44L49.6,396.67l.77.71,13-7.51a4.92,4.92,0,0,0,3.83-.25c1-.6,1.19-1.52.44-2.21l15.2-8.78.25-.14V359.18l68.62-39.62.25-.14v-13.1L164.59,299l24.23,14-85,49.1-.25.14v21.19L62.26,407.27l.86.66,41.15-23.75.25-.15V362.84l85.3-49.25,10.87,6.28-14.91,8.61-.25.15v22.18L83.18,409.9l17.75,10.25a1.22,1.22,0,0,0-.08,2.09l-7.57,4.37,1.07.54,7.56-4.36a5,5,0,0,0,3.35-.14l12.49,7.21-7.87,4.55,1.15.49,8.72-5L106.17,422a1.15,1.15,0,0,0-.06-1.66l27.36-15.79.25-.15V393.25l97-56,12.79,7.39-87.08,50.27-.25.14v15l-17.54,10.13-.25.14v16.35l-9.12,5.26,1.25.43,92.8-53.58.25-.14V373.19l34.72-20.05.93.54v22.19l13.79,8-16.92,9.77H244.21l-94.45,54.54,1.36.36,93.36-53.9H256.4l17.65-10.19,12.78,7.38L257,409c-.95.15-10.27.23-15.15.23h-.13l-74.75,43.05,1.47.3,73.54-42.35c2,0,14.9,0,15.46-.33l30.43-17.57,12.8,7.39-44.79,25.86H237.26L207,443.22h-8.12L179,454.7l1.53.27,18.64-10.75h8.12l30.22-17.61H256.1l45.52-26.28,24.6,14.2H294.3l-42.67,24.63a5,5,0,0,0-3.83.26,1.34,1.34,0,0,0,0,2.53,4.81,4.81,0,0,0,4.4,0c1-.6,1.18-1.52.43-2.21l41.94-24.21h60.6l-29.78,17.19H294.1l-44.36,25.61.5.86,44.13-25.47h29.29L281.3,458.17l.5.87,75.37-43.51h9.63l5.39,3.11-16.08,9.28a4.92,4.92,0,0,0-3.83.25,1.34,1.34,0,0,0,0,2.54,4.85,4.85,0,0,0,4.39,0c1.05-.6,1.19-1.52.44-2.21l16.08-9.28L395,431.82l1.11-.51-28.95-16.72h0l-.08,0h0L296,373.64c.74-.69.6-1.61-.44-2.21a4.85,4.85,0,0,0-4.39,0,1.34,1.34,0,0,0,0,2.54,4.92,4.92,0,0,0,3.83.25l70.09,40.31H328.22l-68-39.24V353.11l-.93-.54,8.84-5.11,137,79.08.11.07h.51l1.93-1h-2.17L269.17,346.88l12.8-7.39,122,70.44c1,.58,17.34.25,24.47.07l2.58,1.49.91-.63L428.7,409h-.14c-8.76.22-23.06.42-24.09.07L283,338.92l11.17-6.45a2.38,2.38,0,0,0,.51.4,4.92,4.92,0,0,0,3.83.25l106.37,61.42.12.06h25.79L443.48,402l.8-.69-13.14-7.59-.12-.07H405.24l-95.39-55.07h28.61l56.05,32.36c-.75.69-.6,1.61.44,2.21a4.85,4.85,0,0,0,4.39,0,1.34,1.34,0,0,0,0-2.53,4.88,4.88,0,0,0-3.83-.26L338.85,337.6l-.12-.07H308.12l-8.64-5c.75-.69.6-1.61-.44-2.21a3.86,3.86,0,0,0-.69-.29l32.33-18.67,107.07,61.82v15.39ZM430.41,302.4l-6.33-3.66,6.33-3.65Zm17.8-33.93v15.19l-25.13,14.51-13.16-7.6ZM304,309.71l-12.8-7.39,13.49-7.79,1.57.9.12.07h.14c7.24-.18,18.25-.35,22.44-.21Zm-78.61-17.82-18,10.37v-2.19l-22.34-12.89,27-15.62v12.67Zm-10.07-22.16,24.23,14-13.15,7.6-13.26-7.65V271Zm-2.18.1v-1.36l1.18.68Zm19.33,38a4.16,4.16,0,0,0-1.53-.48v-3.78l7.33-4.23,28.06,16.2-12,6.9L232.93,310C233.67,309.33,233.53,308.41,232.49,307.81ZM266.1,289H254.22l-1.78,1-10.87-6.28,7.72-4.45Zm-15.81-10.29,12-6.9h3.06l28.77,16.61-1,.58h-25Zm1.15,11.89-13.15,7.6-10.87-6.28,13.15-7.6Zm-14.15,8.17L231,302.4v-7.31Zm2,0,13.15-7.59,28.07,16.2-13.16,7.59Zm14.15-8.17,1-.6h13.36l21.38,12.35-7.71,4.45Zm16.39-.6h23.51l1.74-1,8.63,5-13.49,7.79Zm26.25-1.58,16.45-9.5h17l.12.07-25,14.41Zm-1-.58-27.78-16h26.24l1.69-1,13.89,8,.11.07h1.3Zm.15-18.16-14.65-8.46,18.8-10.85L314,258.79Zm-1,.57-1,.56h-27.7l-.79-.46,14.8-8.55Zm-44.94,7.89-24.23-14,16.45-9.51a1.93,1.93,0,0,0,.76.74,4.85,4.85,0,0,0,4.39,0,1.86,1.86,0,0,0,.78-.77h19.7l11.44,6.61Zm-1,.57-7.72,4.46-24.23-14,7.72-4.46Zm-40.84,24.73,19-11,3.55,2.05V303l-18.42,10.63-4.09-2.37Zm22.51.72v3.17a4.51,4.51,0,0,0-1.87.51,1.34,1.34,0,0,0,0,2.54,5,5,0,0,0,3.84.25L253.4,323l-12.79,7.39-28.07-16.21Zm24.44,19.45L267.2,331l-12.8,7.39L241.61,331Zm1-.58,12-6.9,5.7,3.29.5-.87-5.2-3,13.16-7.59,12.79,7.38-26.1,15.08Zm27.11-15.65,7.71-4.45,12.8,7.38-7.72,4.46Zm72.2-12.85c-6.63-.17-21.19-.47-24,0-2.83-.43-17.39-.13-24,0l-.94-.55,25-14.42,25,14.42Zm10.58-6.11-8.64,5-25-14.41.13-.07h17Zm-34.61-20,16.42,9.48H331.54l-.86.49-.74-.43-.11-.06H314.27Zm-1-.58-17.41,10.06H309.5l-13.27-7.67L315,259.37Zm-23.1-21.65V230.06l40.83-23.56a5,5,0,0,0,3.36,0l25.29,14.61A1.2,1.2,0,0,0,376,223l-61,35.2-14.65-8.45,5.95-3.44Zm-1-15.54v15l-6.2,3.58-12.95-7.48Zm-20.15,11.64,12.95,7.48-18.8,10.85-12.05-7-.12-.07h-1.56Zm-51.62-13.23,18.77,10.84h28.7l3.15,1.81-19.85,11.46H247.12a2.52,2.52,0,0,0-.46-.35,4.92,4.92,0,0,0-3.83-.25L218,238.2Zm-34.19,19.74,17.34-10,24.87,14.36a1.62,1.62,0,0,0-.25.28l-17.52,10.12-24.44-14.11Zm0,1.8,23.44,13.53-7.72,4.45-15.72-9.08ZM199.37,262l.25-.14v-1.24l12.54,7.24v2.52l-28,16.19-5.67-3.28,15-8.68-8-4.61Zm-28.9,16.69,14-8.11,7,4-14,8.11Zm-10.08,16.72a1.17,1.17,0,0,0,.11-1.76l16.94-9.78,5.67,3.28-18.52,10.69Zm5.2,3,18.52-10.69,22.34,12.89v2.19l-16.63,9.6ZM190.82,313l15.63-9v7.83l4.09,2.36-8.85,5.11ZM133,392.53l-.25.15v11.17l-27.55,15.9a5.2,5.2,0,0,0-3.15-.13L85.18,409.9l101.1-58.37.25-.14V329.2l15.16-8.75,28.07,16.2Zm69.72-72.66,8.85-5.11L239.61,331l-8.85,5.11Zm29.07,16.78,8.85-5.11,12.79,7.39L244.55,344Zm-8.9,35.81-.25.15V388l-83.18,48V420.84L199.82,386l-.5-.86-42.1,24.3v-13.8l87.33-50.42,12.78,7.38ZM258.33,352l-12.78-7.38,8.85-5.1,12.77,7.37Zm9.84-5.69-12.77-7.37,12.8-7.39L281,338.92Zm28.18-16.47a4.33,4.33,0,0,0-1.7.5,1.56,1.56,0,0,0-.9,1.21L282,338.34,269.2,331l26.1-15.07,1.05.6Zm1-.37V315.92l-1.05-.61,7.72-4.45.06,0h25.43Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,262.65l-39.2,22.63c-.29.56-.59,1.11-.87,1.66l41.2-23.79H93.53l13.85,8-9.52,5.49a4.93,4.93,0,0,0-3.83.25,2,2,0,0,0-.77.77h-36L18.47,300.05c-.15.47-.3.94-.44,1.41l39.48-22.8H93.26a1.89,1.89,0,0,0,.77.77,4.87,4.87,0,0,0,4.4,0c1-.6,1.18-1.52.43-2.21l9.52-5.5,7.3,4.22.5-.87-6.8-3.92L125.24,262l7.29,4.22.5-.87-6.8-3.92,17.9-10.34,7.3,4.22.5-.87-6.8-3.92,7.72-4.46,3.48,2,.5-.87-3-1.72,11-6.33-.5-.86-11.45,6.61-13.28-7.67c.81-.69.69-1.65-.38-2.27a5,5,0,0,0-3.93-.22l-1-.59V217.8L122.4,211l-1.22.46,12,6.95v15.19L105.8,217.74l-1.11.51,29.61,17.1c-.68.68-.52,1.57.49,2.15a4.9,4.9,0,0,0,3.73.29l13.33,7.69-7.72,4.45L96.21,222.27l-1.06.54,48,27.7-17.89,10.33-23.07-13.32-.12-.07H82a2,2,0,0,0-.72-.68,4.94,4.94,0,0,0-3.73-.28L66.4,240l-.88.64,11,6.36c-.81.7-.69,1.65.38,2.27a4.87,4.87,0,0,0,4.4,0,1.83,1.83,0,0,0,.81-.86h19.68l22.45,13-15.86,9.15L93.8,262.15H65.1l-15.17-8.76-.76.72Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.06,233a4.87,4.87,0,0,0,4.4,0,1.34,1.34,0,0,0,0-2.54,4.61,4.61,0,0,0-2.4-.5l-2.89,1.71A1.49,1.49,0,0,0,80.06,233Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.22,348.88l34.29-19.8-.5-.86L56,347.88H40.87l-19.1,11c.13.3.26.61.4.92l19-10.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.41,368.42l-.5-.87-23,13.26H35l.78,1h7.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.47,341.82,90,341,30.84,375.09c.19.28.37.56.56.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.61,226.68l55.05-31.78-1.56-.26-54,31.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298.05,192.35l-1.65-.19-12.23,7.06.5.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.47,207.44l-16.84,9.72a5.17,5.17,0,0,0-3.14.13l-23.36-13.48-1.32.39,23.74,13.7a1.16,1.16,0,0,0-.06,1.66L152.9,227.4l21.72,12.54.5-.86L154.9,227.4l12.49-7.21a5,5,0,0,0,3.36.14l18.92,10.92.5-.86-18.36-10.6a1.23,1.23,0,0,0-.08-2.1l17.74-10.25-17.93-10.35-1.46.31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.58,206V191.13l-1,.09v14.17l-24.15,14a4.92,4.92,0,0,0-3.83.25,1.34,1.34,0,0,0,0,2.54,4.87,4.87,0,0,0,4.4,0c1-.61,1.18-1.53.43-2.22l23.9-13.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M450.33,395.84l.75-.72L438.75,388V372.61L331.56,310.72l-.44-.76-.44.25-.44-.25-.11-.07H305.69l25-14.43,137.65,79.48.56-.83L332.4,295.3c4.24-.15,15.21,0,22.43.2H355l1.68-1,118.69,68.52c.15-.3.3-.6.44-.9L357.65,294l8.64-5,1.62.94h0l.08.05,0,0h0L450,337.09c-.73.69-.59,1.6.45,2.2a4.85,4.85,0,0,0,4.39,0,1.34,1.34,0,0,0,0-2.54,4.93,4.93,0,0,0-3.85-.24L370,290h23.33l0,.07.12-.07h13.35l68,39.23v22.19l4.48,2.59c.12-.32.23-.64.34-1l-3.82-2.21V328.63l-25-14.45,4.1-2.36V300.65l21-12.13c-.14-.3-.29-.6-.44-.9l-21.32,12.31-.25.14v11.17l-4.1,2.37L431.41,303v-8.47L449,284.38l.25-.15V267.89l9.06-5.24-.68-.76L408.92,290l-1.65-.95-.12-.07H395.26l56.8-32.79-.75-.72L393.26,289h-25l-1-.58L398,270.69l-.5-.87-31.16,18-15.46-8.92h1.3l42.09-24.31h19.71a1.89,1.89,0,0,0,.77.77,4.87,4.87,0,0,0,4.4,0c1-.6,1.18-1.52.43-2.21l17.33-10-.86-.66-17.47,10.08a4.93,4.93,0,0,0-3.83.25,2,2,0,0,0-.77.77H394l-42.1,24.31H349.1l-17.42-10.06,48.4-27.94h28.7l12.65-7.31-1-.59-12,6.9h-28.7l-49.14,28.36L316,258.79l61-35.2a5,5,0,0,0,3.36,0l16.06,9.27,12.68-7.32-1-.55-11.64,6.72L381.33,223a1.18,1.18,0,0,0-.05-1.83l8.49-4.9-1.14-.5-8.35,4.82a5.23,5.23,0,0,0-3.18,0l-17-9.84,5.94-3.43c-.42-.14-.84-.29-1.27-.42l-5.67,3.27-7.33-4.23c.68-.68.52-1.57-.49-2.15a4.81,4.81,0,0,0-4.4,0c-1,.6-1.18,1.52-.43,2.21l-61,35.2L281.67,239l-.12-.06H261.48l33.14-19.14h15.09l33.22-19.18-1.41-.34-32.08,18.52H294.35l-34.28,19.8.19.34h-7.41l-18-10.42,33.43-19.3.25-.14V189.89l-1,0v18.61l-33.68,19.44-3.1-1.79-.5.87,2.6,1.5L217,237.63l-3.11-1.8-.5.87,2.61,1.5-17.09,9.87-.25.14v.64L195,246.74l-.5.86,4.16,2.41v8.91l-8.56-5-.5.87,9.06,5.23v1.24l-14.11,8.15-12.74-7.36-.5.86L183.51,270l-14,8.11-12.75-7.35-.5.86,12.25,7.07-60.19,34.75H85.73L45,337V322L246.81,205.51l.25-.14V189.46h-1v15.33L88.33,295.86H57L14.58,320.37c0,.4-.06.8-.08,1.2l42.81-24.71H86.6L44.25,321.31l-.25.14v16.12L19,352l.34,1L86,314.47h22.55l60.92-35.17,7,4-16.86,9.74a4.92,4.92,0,0,0-4,.17,1.34,1.34,0,0,0,0,2.54,5,5,0,0,0,3.84.25l4.2,2.43-12.38,7.15-.25.14v13.1L82.34,358.46l-.25.14v19.31l-15.45,8.92a4.92,4.92,0,0,0-3.83.25,1.89,1.89,0,0,0-.77.77H40.91c.3.33.6.67.91,1H62a1.45,1.45,0,0,0,.33.44L49.6,396.67l.77.71,13-7.51a4.92,4.92,0,0,0,3.83-.25c1-.6,1.19-1.52.44-2.21l15.2-8.78.25-.14V359.18l68.62-39.62.25-.14v-13.1L164.59,299l24.23,14-85,49.1-.25.14v21.19L62.26,407.27l.86.66,41.15-23.75.25-.15V362.84l85.3-49.25,10.87,6.28-14.91,8.61-.25.15v22.18L83.18,409.9l17.75,10.25a1.22,1.22,0,0,0-.08,2.09l-7.57,4.37,1.07.54,7.56-4.36a5,5,0,0,0,3.35-.14l12.49,7.21-7.87,4.55,1.15.49,8.72-5L106.17,422a1.15,1.15,0,0,0-.06-1.66l27.36-15.79.25-.15V393.25l97-56,12.79,7.39-87.08,50.27-.25.14v15l-17.54,10.13-.25.14v16.35l-9.12,5.26,1.25.43,92.8-53.58.25-.14V373.19l34.72-20.05.93.54v22.19l13.79,8-16.92,9.77H244.21l-94.45,54.54,1.36.36,93.36-53.9H256.4l17.65-10.19,12.78,7.38L257,409c-.95.15-10.27.23-15.15.23h-.13l-74.75,43.05,1.47.3,73.54-42.35c2,0,14.9,0,15.46-.33l30.43-17.57,12.8,7.39-44.79,25.86H237.26L207,443.22h-8.12L179,454.7l1.53.27,18.64-10.75h8.12l30.22-17.61H256.1l45.52-26.28,24.6,14.2H294.3l-42.67,24.63a5,5,0,0,0-3.83.26,1.34,1.34,0,0,0,0,2.53,4.81,4.81,0,0,0,4.4,0c1-.6,1.18-1.52.43-2.21l41.94-24.21h60.6l-29.78,17.19H294.1l-44.36,25.61.5.86,44.13-25.47h29.29L281.3,458.17l.5.87,75.37-43.51h9.63l5.39,3.11-16.08,9.28a4.92,4.92,0,0,0-3.83.25,1.34,1.34,0,0,0,0,2.54,4.85,4.85,0,0,0,4.39,0c1.05-.6,1.19-1.52.44-2.21l16.08-9.28L395,431.82l1.11-.51-28.95-16.72h0l-.08,0h0L296,373.64c.74-.69.6-1.61-.44-2.21a4.85,4.85,0,0,0-4.39,0,1.34,1.34,0,0,0,0,2.54,4.92,4.92,0,0,0,3.83.25l70.09,40.31H328.22l-68-39.24V353.11l-.93-.54,8.84-5.11,137,79.08.11.07h.51l1.93-1h-2.17L269.17,346.88l12.8-7.39,122,70.44c1,.58,17.34.25,24.47.07l2.58,1.49.91-.63L428.7,409h-.14c-8.76.22-23.06.42-24.09.07L283,338.92l11.17-6.45a2.38,2.38,0,0,0,.51.4,4.92,4.92,0,0,0,3.83.25l106.37,61.42.12.06h25.79L443.48,402l.8-.69-13.14-7.59-.12-.07H405.24l-95.39-55.07h28.61l56.05,32.36c-.75.69-.6,1.61.44,2.21a4.85,4.85,0,0,0,4.39,0,1.34,1.34,0,0,0,0-2.53,4.88,4.88,0,0,0-3.83-.26L338.85,337.6l-.12-.07H308.12l-8.64-5c.75-.69.6-1.61-.44-2.21a3.86,3.86,0,0,0-.69-.29l32.33-18.67,107.07,61.82v15.39ZM430.41,302.4l-6.33-3.66,6.33-3.65Zm17.8-33.93v15.19l-25.13,14.51-13.16-7.6ZM304,309.71l-12.8-7.39,13.49-7.79,1.57.9.12.07h.14c7.24-.18,18.25-.35,22.44-.21Zm-78.61-17.82-18,10.37v-2.19l-22.34-12.89,27-15.62v12.67Zm-10.07-22.16,24.23,14-13.15,7.6-13.26-7.65V271Zm-2.18.1v-1.36l1.18.68Zm19.33,38a4.16,4.16,0,0,0-1.53-.48v-3.78l7.33-4.23,28.06,16.2-12,6.9L232.93,310C233.67,309.33,233.53,308.41,232.49,307.81ZM266.1,289H254.22l-1.78,1-10.87-6.28,7.72-4.45Zm-15.81-10.29,12-6.9h3.06l28.77,16.61-1,.58h-25Zm1.15,11.89-13.15,7.6-10.87-6.28,13.15-7.6Zm-14.15,8.17L231,302.4v-7.31Zm2,0,13.15-7.59,28.07,16.2-13.16,7.59Zm14.15-8.17,1-.6h13.36l21.38,12.35-7.71,4.45Zm16.39-.6h23.51l1.74-1,8.63,5-13.49,7.79Zm26.25-1.58,16.45-9.5h17l.12.07-25,14.41Zm-1-.58-27.78-16h26.24l1.69-1,13.89,8,.11.07h1.3Zm.15-18.16-14.65-8.46,18.8-10.85L314,258.79Zm-1,.57-1,.56h-27.7l-.79-.46,14.8-8.55Zm-44.94,7.89-24.23-14,16.45-9.51a1.93,1.93,0,0,0,.76.74,4.85,4.85,0,0,0,4.39,0,1.86,1.86,0,0,0,.78-.77h19.7l11.44,6.61Zm-1,.57-7.72,4.46-24.23-14,7.72-4.46Zm-40.84,24.73,19-11,3.55,2.05V303l-18.42,10.63-4.09-2.37Zm22.51.72v3.17a4.51,4.51,0,0,0-1.87.51,1.34,1.34,0,0,0,0,2.54,5,5,0,0,0,3.84.25L253.4,323l-12.79,7.39-28.07-16.21Zm24.44,19.45L267.2,331l-12.8,7.39L241.61,331Zm1-.58,12-6.9,5.7,3.29.5-.87-5.2-3,13.16-7.59,12.79,7.38-26.1,15.08Zm27.11-15.65,7.71-4.45,12.8,7.38-7.72,4.46Zm72.2-12.85c-6.63-.17-21.19-.47-24,0-2.83-.43-17.39-.13-24,0l-.94-.55,25-14.42,25,14.42Zm10.58-6.11-8.64,5-25-14.41.13-.07h17Zm-34.61-20,16.42,9.48H331.54l-.86.49-.74-.43-.11-.06H314.27Zm-1-.58-17.41,10.06H309.5l-13.27-7.67L315,259.37Zm-23.1-21.65V230.06l40.83-23.56a5,5,0,0,0,3.36,0l25.29,14.61A1.2,1.2,0,0,0,376,223l-61,35.2-14.65-8.45,5.95-3.44Zm-1-15.54v15l-6.2,3.58-12.95-7.48Zm-20.15,11.64,12.95,7.48-18.8,10.85-12.05-7-.12-.07h-1.56Zm-51.62-13.23,18.77,10.84h28.7l3.15,1.81-19.85,11.46H247.12a2.52,2.52,0,0,0-.46-.35,4.92,4.92,0,0,0-3.83-.25L218,238.2Zm-34.19,19.74,17.34-10,24.87,14.36a1.62,1.62,0,0,0-.25.28l-17.52,10.12-24.44-14.11Zm0,1.8,23.44,13.53-7.72,4.45-15.72-9.08ZM199.37,262l.25-.14v-1.24l12.54,7.24v2.52l-28,16.19-5.67-3.28,15-8.68-8-4.61Zm-28.9,16.69,14-8.11,7,4-14,8.11Zm-10.08,16.72a1.17,1.17,0,0,0,.11-1.76l16.94-9.78,5.67,3.28-18.52,10.69Zm5.2,3,18.52-10.69,22.34,12.89v2.19l-16.63,9.6ZM190.82,313l15.63-9v7.83l4.09,2.36-8.85,5.11ZM133,392.53l-.25.15v11.17l-27.55,15.9a5.2,5.2,0,0,0-3.15-.13L85.18,409.9l101.1-58.37.25-.14V329.2l15.16-8.75,28.07,16.2Zm69.72-72.66,8.85-5.11L239.61,331l-8.85,5.11Zm29.07,16.78,8.85-5.11,12.79,7.39L244.55,344Zm-8.9,35.81-.25.15V388l-83.18,48V420.84L199.82,386l-.5-.86-42.1,24.3v-13.8l87.33-50.42,12.78,7.38ZM258.33,352l-12.78-7.38,8.85-5.1,12.77,7.37Zm9.84-5.69-12.77-7.37,12.8-7.39L281,338.92Zm28.18-16.47a4.33,4.33,0,0,0-1.7.5,1.56,1.56,0,0,0-.9,1.21L282,338.34,269.2,331l26.1-15.07,1.05.6Zm1-.37V315.92l-1.05-.61,7.72-4.45.06,0h25.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64,262.65l-39.2,22.63c-.29.56-.59,1.11-.87,1.66l41.2-23.79H93.53l13.85,8-9.52,5.49a4.93,4.93,0,0,0-3.83.25,2,2,0,0,0-.77.77h-36L18.47,300.05c-.15.47-.3.94-.44,1.41l39.48-22.8H93.26a1.89,1.89,0,0,0,.77.77,4.87,4.87,0,0,0,4.4,0c1-.6,1.18-1.52.43-2.21l9.52-5.5,7.3,4.22.5-.87-6.8-3.92L125.24,262l7.29,4.22.5-.87-6.8-3.92,17.9-10.34,7.3,4.22.5-.87-6.8-3.92,7.72-4.46,3.48,2,.5-.87-3-1.72,11-6.33-.5-.86-11.45,6.61-13.28-7.67c.81-.69.69-1.65-.38-2.27a5,5,0,0,0-3.93-.22l-1-.59V217.8L122.4,211l-1.22.46,12,6.95v15.19L105.8,217.74l-1.11.51,29.61,17.1c-.68.68-.52,1.57.49,2.15a4.9,4.9,0,0,0,3.73.29l13.33,7.69-7.72,4.45L96.21,222.27l-1.06.54,48,27.7-17.89,10.33-23.07-13.32-.12-.07H82a2,2,0,0,0-.72-.68,4.94,4.94,0,0,0-3.73-.28L66.4,240l-.88.64,11,6.36c-.81.7-.69,1.65.38,2.27a4.87,4.87,0,0,0,4.4,0,1.83,1.83,0,0,0,.81-.86h19.68l22.45,13-15.86,9.15L93.8,262.15H65.1l-15.17-8.76-.76.72Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.06,233a4.87,4.87,0,0,0,4.4,0,1.34,1.34,0,0,0,0-2.54,4.61,4.61,0,0,0-2.4-.5l-2.89,1.71A1.49,1.49,0,0,0,80.06,233Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-3",
    cx: 356.84,
    cy: 405.16,
    rx: 26.15,
    ry: 15.1,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-3",
    cx: 138.97,
    cy: 398.13,
    rx: 26.15,
    ry: 15.1,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.26,134.6l123.5-70.85c1.73-1,3.14-.19,3.14,1.82v91.34a7,7,0,0,1-3.14,5.44L32.26,233.2c-1.74,1-3.15.19-3.15-1.81V140.05A7,7,0,0,1,32.26,134.6Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.26,134.6l123.5-70.85c1.73-1,3.14-.19,3.14,1.82v91.34a7,7,0,0,1-3.14,5.44L32.26,233.2c-1.74,1-3.15.19-3.15-1.81V140.05A7,7,0,0,1,32.26,134.6Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.16,64.32h0c.64,0,.74.78.74,1.25v91.34a5.93,5.93,0,0,1-2.64,4.57L31.76,232.34a1.9,1.9,0,0,1-.91.29c-.64,0-.74-.78-.74-1.24V140.05a5.94,5.94,0,0,1,2.64-4.58L156.26,64.62a1.78,1.78,0,0,1,.9-.3m0-1a2.85,2.85,0,0,0-1.4.43L32.26,134.6a7,7,0,0,0-3.15,5.45v91.34c0,1.42.71,2.24,1.74,2.24a2.91,2.91,0,0,0,1.41-.43l123.5-70.85a7,7,0,0,0,3.14-5.44V65.57c0-1.43-.71-2.25-1.74-2.25Z",
    style: {
      fill: "#31859B",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.93,214.21a202.89,202.89,0,0,1,1.51-21.56c.92-7.78,2.81-20.89,10.31-25.22s10.31,3.49,11.39,7.34c1.41,5,8.74,1.84,9.77-6.4s1.68-34.48,10.46-39.55S99,136,100,139.37c2,6.69,7.74,4.85,9.62.41s7-5.52,8.95.72,3.15,13.4,9.43,9.72c5.51-3.22,3-9.11,8.36-11.89,4.25-2.21,6.22,8.29,6.22,18.92Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.82,162.1c0,1.15,1,1.48,2.29.75l12.45-7.17a4.57,4.57,0,0,0,2.29-3.39c0-1.15-1-1.48-2.29-.75l-12.45,7.17A4.6,4.6,0,0,0,44.82,162.1Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.66,125.31c0,1.14,1,1.47,2.3.74l12.44-7.16a4.62,4.62,0,0,0,2.3-3.4c0-1.14-1-1.48-2.3-.75L82,121.91A4.59,4.59,0,0,0,79.66,125.31Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15,130.1c0,1.15,1,1.48,2.3.75l12.44-7.17a4.59,4.59,0,0,0,2.3-3.39c0-1.15-1-1.48-2.3-.75l-12.44,7.17A4.59,4.59,0,0,0,104.15,130.1Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.05,135.36c0,1.14,1,1.48,2.29.74l12.45-7.16a4.57,4.57,0,0,0,2.29-3.4c0-1.14-1-1.48-2.29-.74L129.34,132A4.6,4.6,0,0,0,127.05,135.36Z",
    style: {
      fill: "#31859B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,168.93a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1A.51.51,0,0,1,55.75,168.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,203.26a.5.5,0,0,1-.5-.5v-1.91a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v1.91A.5.5,0,0,1,55.75,203.26Zm0-5.72a.5.5,0,0,1-.5-.5v-1.91a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V197A.51.51,0,0,1,55.75,197.54Zm0-5.72a.5.5,0,0,1-.5-.5v-1.91a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1.91A.51.51,0,0,1,55.75,191.82Zm0-5.73a.5.5,0,0,1-.5-.5v-1.9a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1.9A.5.5,0,0,1,55.75,186.09Zm0-5.72a.5.5,0,0,1-.5-.5V178a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v1.91A.5.5,0,0,1,55.75,180.37Zm0-5.72a.5.5,0,0,1-.5-.5v-1.91a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1.91A.51.51,0,0,1,55.75,174.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,208.08a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1A.51.51,0,0,1,55.75,208.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.74,138a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1A.5.5,0,0,1,113.74,138Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.74,169.33a.5.5,0,0,1-.5-.5v-2.09a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v2.09A.5.5,0,0,1,113.74,169.33Zm0-6.27a.5.5,0,0,1-.5-.5v-2.08a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.08A.5.5,0,0,1,113.74,163.06Zm0-6.26a.5.5,0,0,1-.5-.5v-2.09a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.09A.51.51,0,0,1,113.74,156.8Zm0-6.27a.5.5,0,0,1-.5-.5v-2.09a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V150A.51.51,0,0,1,113.74,150.53Zm0-6.27a.5.5,0,0,1-.5-.5v-2.09a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.09A.5.5,0,0,1,113.74,144.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.74,174.51a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v1A.5.5,0,0,1,113.74,174.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,139.83a.51.51,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.41,156.67a.5.5,0,0,1-.5-.5V154.3a.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,.5.5v1.87A.5.5,0,0,1,136.41,156.67Zm0-5.61a.51.51,0,0,1-.5-.5v-1.87a.5.5,0,0,1,.5-.5h0a.49.49,0,0,1,.5.49v1.88a.5.5,0,0,1-.5.5Zm0-5.62a.5.5,0,0,1-.5-.5v-1.87a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v1.87a.5.5,0,0,1-.5.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.42,161.42a.51.51,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5.54.54,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.36,129.43a.5.5,0,0,1-.5-.5v-1a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v1A.5.5,0,0,1,89.36,129.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.36,183.57a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,183.57Zm0-6a.51.51,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,177.56Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,171.54Zm0-6a.51.51,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,165.53Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,159.51Zm0-6a.51.51,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,153.5Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,147.48Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,141.46Zm0-6a.51.51,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,89.36,135.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.36,188.58a.5.5,0,0,1-.5-.5v-1a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v1A.5.5,0,0,1,89.36,188.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.48,134.6,344,63.75c-1.73-1-3.14-.19-3.14,1.82v91.34a7,7,0,0,0,3.14,5.44L467.48,233.2c1.73,1,3.14.19,3.14-1.81V140.05A7,7,0,0,0,467.48,134.6Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.48,134.6,344,63.75c-1.73-1-3.14-.19-3.14,1.82v91.34a7,7,0,0,0,3.14,5.44L467.48,233.2c1.73,1,3.14.19,3.14-1.81V140.05A7,7,0,0,0,467.48,134.6Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.57,64.32a1.84,1.84,0,0,1,.91.3L467,135.47a5.94,5.94,0,0,1,2.64,4.58v91.34c0,.46-.1,1.24-.74,1.24a1.9,1.9,0,0,1-.91-.29l-123.5-70.86a5.93,5.93,0,0,1-2.64-4.57V65.57c0-.47.1-1.25.74-1.25m0-1c-1,0-1.74.82-1.74,2.25v91.34a7,7,0,0,0,3.14,5.44L467.48,233.2a2.85,2.85,0,0,0,1.4.43c1,0,1.74-.82,1.74-2.24V140.05a7,7,0,0,0-3.14-5.45L344,63.75a2.85,2.85,0,0,0-1.4-.43Z",
    style: {
      fill: "#31859B",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.34 155.26 349.34 151.19 361.52 139.46 370.65 158.81 379.83 148.25 387.24 161.71 408.8 133.86 417.64 153.81 431.29 132.98 449.66 185.96 463.07 202.78 463.07 220.92 349.34 155.26",
    style: {
      fill: "#31859B",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.29,203a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,203Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,197Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,191Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,185Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,179Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,173Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,167Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,161Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,155Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,149Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,143Zm0-6a.5.5,0,0,1-.5-.5v-2a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,431.29,137Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.88,186.06a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,186.06Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,180.06Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,174.06Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,168.06Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,162.06Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,156.06Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,150.06Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,144.06Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,408.88,138.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.52,162a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,361.52,162Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,361.52,156Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,361.52,150Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,361.52,144Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.57,170.38a.51.51,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,379.57,170.38Zm0-6a.51.51,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,379.57,164.38Zm0-6a.51.51,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,379.57,158.38Zm0-6a.51.51,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,379.57,152.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,133.51c0,1.14-1,1.48-2.29.75L358.44,130a4.6,4.6,0,0,1-2.29-3.39c0-1.15,1-1.48,2.29-.75l7.26,4.23A4.57,4.57,0,0,1,368,133.51Z",
    style: {
      fill: "#31859B",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.89,146.79c0,1.15-1,1.48-2.29.75l-7.25-4.23a4.59,4.59,0,0,1-2.3-3.39c0-1.14,1-1.48,2.3-.75l7.25,4.23A4.57,4.57,0,0,1,385.89,146.79Z",
    style: {
      fill: "#31859B",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.8,130.5c0,1.14-1,1.48-2.29.75L405.25,127a4.6,4.6,0,0,1-2.29-3.4c0-1.14,1-1.47,2.29-.74l7.26,4.22A4.61,4.61,0,0,1,414.8,130.5Z",
    style: {
      fill: "#31859B",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.36,130c0,1.14-1,1.48-2.3.74l-7.25-4.22a4.59,4.59,0,0,1-2.3-3.4c0-1.14,1-1.47,2.3-.74l7.25,4.22A4.62,4.62,0,0,1,438.36,130Z",
    style: {
      fill: "#31859B",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stage--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--stage--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.31,293.36l-137.9,79.55a14.17,14.17,0,0,1-12.85,0L105.69,293.37c-1.78-1-2.67-2.35-2.67-3.71a3.8,3.8,0,0,1,1.41-2.79,6.29,6.29,0,0,1,1.26-.91l137.9-79.53a14.19,14.19,0,0,1,12.85,0l137.87,79.51C397.85,288,397.85,291.33,394.31,293.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,336.28v26.8a13.1,13.1,0,0,1-6.4-1.51L105.69,282c-1.78-1-2.67-2.37-2.67-3.71V255.11a3.8,3.8,0,0,1,1.41-2.8l19.95,11.52Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,336.28v26.8a13.1,13.1,0,0,1-6.4-1.51L105.69,282c-1.78-1-2.67-2.37-2.67-3.71V255.11a3.8,3.8,0,0,1,1.41-2.8l19.95,11.52Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,336.28v26.8a13.11,13.11,0,0,0,6.41-1.51L394.31,282c1.78-1,2.67-2.37,2.67-3.71V255.1a3.8,3.8,0,0,0-1.41-2.8l-19.95,11.52Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,336.28v26.8a13.11,13.11,0,0,0,6.41-1.51L394.31,282c1.78-1,2.67-2.37,2.67-3.71V255.1a3.8,3.8,0,0,0-1.41-2.8l-19.95,11.52Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.31,258.8l-137.9,79.56a14.26,14.26,0,0,1-12.85,0L105.69,258.81c-1.78-1-2.67-2.34-2.67-3.7a3.8,3.8,0,0,1,1.41-2.8,6.29,6.29,0,0,1,1.26-.91l137.9-79.53a14.19,14.19,0,0,1,12.85,0l137.87,79.52C397.85,253.44,397.85,256.78,394.31,258.8Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.31,258.8l-137.9,79.56a14.26,14.26,0,0,1-12.85,0L105.69,258.81c-1.78-1-2.67-2.34-2.67-3.7a3.8,3.8,0,0,1,1.41-2.8,6.29,6.29,0,0,1,1.26-.91l137.9-79.53a14.19,14.19,0,0,1,12.85,0l137.87,79.52C397.85,253.44,397.85,256.78,394.31,258.8Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,171.92a11.69,11.69,0,0,1,5.64,1.33l137.86,79.51c1.19.69,1.86,1.54,1.86,2.35s-.68,1.64-1.85,2.32L255.61,337a12.67,12.67,0,0,1-11.26,0L106.48,257.43c-1.19-.67-1.87-1.52-1.87-2.32a2.31,2.31,0,0,1,.9-1.63,4.9,4.9,0,0,1,1-.7l137.91-79.53a11.45,11.45,0,0,1,5.62-1.33m0-1.59a13,13,0,0,0-6.42,1.54L105.69,251.4a6,6,0,0,0-1.26.91,3.8,3.8,0,0,0-1.41,2.8c0,1.36.89,2.69,2.67,3.7l137.87,79.55a14.26,14.26,0,0,0,12.85,0l137.9-79.56c3.54-2,3.54-5.36,0-7.41L256.44,171.87a13.12,13.12,0,0,0-6.43-1.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.73,188l-112,64.62c-2.37,1.37-2.37,3.58,0,4.95l112,64.61a9.43,9.43,0,0,0,8.56,0l112.05-64.62c2.37-1.37,2.37-3.58,0-4.95L254.29,188A9.43,9.43,0,0,0,245.73,188Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.31,252.63,254.29,188a8.77,8.77,0,0,0-4.28-1v4.35L365.57,258l.74-.43C368.68,256.21,368.68,254,366.31,252.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,187a8.77,8.77,0,0,0-4.28,1l-112,64.62c-2.37,1.37-2.37,3.58,0,4.95l.74.43L250,191.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Light--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.74,305.84a13.77,13.77,0,0,1-7.87,1.85c-.05,0,0,0,0,0s0,0,0,0v15.55a9.79,9.79,0,0,0,5.28-1.57L365,258.27c2.05-1.13,3-2.13,3-3.5V242.2Z",
    style: {
      fill: "#31859B",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,291.93a13.62,13.62,0,0,1-7.87,1.85h0v15.55a9.79,9.79,0,0,0,5.28-1.57L365,244.36c2.05-1.13,3-2.12,3-3.49V228.3Z",
    style: {
      fill: "#31859B",
      opacity: 0.276923
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,278a13.77,13.77,0,0,1-7.87,1.85c-.05,0,0,0,0,0s0,0,0,0v15.55a9.79,9.79,0,0,0,5.28-1.57L365,230.46c2.05-1.13,3-2.13,3-3.5V214.39Z",
    style: {
      fill: "#31859B",
      opacity: 0.253846
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,264.12a13.62,13.62,0,0,1-7.87,1.85h0v15.55a9.86,9.86,0,0,0,5.28-1.56L365,216.55c2.05-1.13,3-2.12,3-3.49V200.49Z",
    style: {
      fill: "#31859B",
      opacity: 0.230769
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,250.22a13.77,13.77,0,0,1-7.87,1.85c-.05,0,0,0,0,0s0,0,0,0v15.55a9.79,9.79,0,0,0,5.28-1.57L365,202.65c2.05-1.13,3-2.12,3-3.5V186.58Z",
    style: {
      fill: "#31859B",
      opacity: 0.207692
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,236.32a13.69,13.69,0,0,1-7.87,1.84h0v15.55a9.86,9.86,0,0,0,5.28-1.56L365,188.74c2.05-1.12,3-2.12,3-3.49V172.68Z",
    style: {
      fill: "#31859B",
      opacity: 0.184615
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,222.41a13.69,13.69,0,0,1-7.87,1.85c-.05,0,0,0,0,0s0,0,0,0v15.55a9.79,9.79,0,0,0,5.28-1.57L365,174.84c2.05-1.13,3-2.12,3-3.49V158.77Z",
    style: {
      fill: "#31859B",
      opacity: 0.161538
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,208.51a13.69,13.69,0,0,1-7.87,1.84h0V225.9a9.86,9.86,0,0,0,5.28-1.56L365,160.93c2.05-1.12,3-2.12,3-3.49V144.87Z",
    style: {
      fill: "#31859B",
      opacity: 0.138462
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,194.6a13.62,13.62,0,0,1-7.87,1.85c-.05,0,0,0,0,0s0,0,0,0V212a9.79,9.79,0,0,0,5.28-1.57L365,147c2.05-1.13,3-2.12,3-3.49V131Z",
    style: {
      fill: "#31859B",
      opacity: 0.115385
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,180.7a13.69,13.69,0,0,1-7.87,1.84c-.05,0,0,0,0,0h0v15.55a9.86,9.86,0,0,0,5.28-1.56L365,133.12c2.05-1.12,3-2.12,3-3.49V117.06Z",
    style: {
      fill: "#31859B",
      opacity: 0.092308
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,166.79a13.62,13.62,0,0,1-7.87,1.85c-.05,0,0,0,0,0s0,0,0,0v15.55a9.79,9.79,0,0,0,5.28-1.57L365,119.22c2.05-1.13,3-2.12,3-3.49V103.16Z",
    style: {
      fill: "#31859B",
      opacity: 0.069231
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,152.89a13.77,13.77,0,0,1-7.87,1.85c-.05,0,0,0,0,0h0v15.56a9.87,9.87,0,0,0,5.28-1.57L365,105.32c2.05-1.13,3-2.13,3-3.5V89.25Z",
    style: {
      fill: "#31859B",
      opacity: 0.046154
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,139a13.62,13.62,0,0,1-7.87,1.85h0v15.55a9.79,9.79,0,0,0,5.28-1.57L365,91.41c2.05-1.13,3-2.12,3-3.49V75.35Z",
    style: {
      fill: "#31859B",
      opacity: 0.023077
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,125.08a13.77,13.77,0,0,1-7.87,1.85c-.05,0,0,0,0,0s0,0,0,0v15.55a9.79,9.79,0,0,0,5.28-1.57L365,77.51c2.05-1.13,3-2.13,3-3.5V61.44Z",
    style: {
      fill: "#31859B",
      opacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242,305.84a13.79,13.79,0,0,0,7.88,1.85s-.05,0,0,0,0,0,0,0v15.55a9.76,9.76,0,0,1-5.28-1.57l-109.82-63.4c-2.05-1.13-3-2.13-3-3.5V242.2Z",
    style: {
      fill: "#31859B",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,291.93a13.63,13.63,0,0,0,7.88,1.85h0v15.55a9.76,9.76,0,0,1-5.28-1.57l-109.82-63.4c-2.05-1.13-3-2.12-3-3.49V228.3Z",
    style: {
      fill: "#31859B",
      opacity: 0.461538
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,278a13.79,13.79,0,0,0,7.88,1.85s-.05,0,0,0,0,0,0,0v15.55a9.76,9.76,0,0,1-5.28-1.57l-109.82-63.4c-2.05-1.13-3-2.13-3-3.5V214.39Z",
    style: {
      fill: "#31859B",
      opacity: 0.423077
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,264.12a13.63,13.63,0,0,0,7.88,1.85h0v15.55a9.83,9.83,0,0,1-5.28-1.56L134.77,216.55c-2.05-1.13-3-2.12-3-3.49V200.49Z",
    style: {
      fill: "#31859B",
      opacity: 0.384615
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,250.22a13.79,13.79,0,0,0,7.88,1.85s-.05,0,0,0,0,0,0,0v15.55a9.76,9.76,0,0,1-5.28-1.57l-109.82-63.4c-2.05-1.13-3-2.12-3-3.5V186.58Z",
    style: {
      fill: "#31859B",
      opacity: 0.34615399999999996
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,236.32a13.7,13.7,0,0,0,7.88,1.84h0v15.55a9.83,9.83,0,0,1-5.28-1.56L134.77,188.74c-2.05-1.12-3-2.12-3-3.49V172.68Z",
    style: {
      fill: "#31859B",
      opacity: 0.30769199999999997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,222.41a13.71,13.71,0,0,0,7.88,1.85s-.05,0,0,0,0,0,0,0v15.55a9.76,9.76,0,0,1-5.28-1.57l-109.82-63.4c-2.05-1.13-3-2.12-3-3.49V158.77Z",
    style: {
      fill: "#31859B",
      opacity: 0.269231
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,208.51a13.7,13.7,0,0,0,7.88,1.84h0V225.9a9.83,9.83,0,0,1-5.28-1.56L134.77,160.93c-2.05-1.12-3-2.12-3-3.49V144.87Z",
    style: {
      fill: "#31859B",
      opacity: 0.230769
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,194.6a13.63,13.63,0,0,0,7.88,1.85s-.05,0,0,0,0,0,0,0V212a9.76,9.76,0,0,1-5.28-1.57L134.77,147c-2.05-1.13-3-2.12-3-3.49V131Z",
    style: {
      fill: "#31859B",
      opacity: 0.19230799999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,180.7a13.7,13.7,0,0,0,7.88,1.84s-.05,0,0,0h0v15.55a9.83,9.83,0,0,1-5.28-1.56L134.77,133.12c-2.05-1.12-3-2.12-3-3.49V117.06Z",
    style: {
      fill: "#31859B",
      opacity: 0.15384599999999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,166.79a13.63,13.63,0,0,0,7.88,1.85s-.05,0,0,0,0,0,0,0v15.55a9.76,9.76,0,0,1-5.28-1.57l-109.82-63.4c-2.05-1.13-3-2.12-3-3.49V103.16Z",
    style: {
      fill: "#31859B",
      opacity: 0.115385
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,152.89a13.79,13.79,0,0,0,7.88,1.85s-.05,0,0,0,0,0,0,0v15.56a9.85,9.85,0,0,1-5.28-1.57l-109.82-63.4c-2.05-1.13-3-2.13-3-3.5V89.25Z",
    style: {
      fill: "#31859B",
      opacity: 0.07692299999999999
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,139a13.63,13.63,0,0,0,7.88,1.85h0v15.55a9.76,9.76,0,0,1-5.28-1.57L134.77,91.41c-2.05-1.13-3-2.12-3-3.49V75.35Z",
    style: {
      fill: "#31859B",
      opacity: 0.038461999999999996
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,125.08a13.79,13.79,0,0,0,7.88,1.85s-.05,0,0,0,0,0,0,0v15.55a9.76,9.76,0,0,1-5.28-1.57L134.77,77.51c-2.05-1.13-3-2.13-3-3.5V61.44Z",
    style: {
      fill: "#31859B",
      opacity: 0
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brain--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--brain--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.81,196.23s3.34,3.33,1,9.49c-2.23,6-9.53,7-9.53,7s1,9.81-14.92,11a10,10,0,0,0,0-2.06s7.31-.29,7.42-11.64-8.4-13.1-8.4-13.1a10.41,10.41,0,0,0,1.32-9.12c-2.08-6.22-6.48-5.56-6.48-5.56s3.19-2.34,1.79-8.14c-1.3-5.39-5.35-6.09-5.35-6.09s3-5.36-2.47-12.6-11.09-6.12-11.09-6.12a16.31,16.31,0,0,0-3.88-9.7c-3.89-4.53-10-3.89-10-3.89A15.79,15.79,0,0,0,264,123.52c-5.82-5.5-11.66-5.25-11.66-5.25a9.32,9.32,0,0,0-3.93-8.11,10.71,10.71,0,0,0-10.54-1.51s-1-7.12-7.16-8.48c-8.05-1.76-12,3-12,3s-2.68-3.53-8.81-4.53A31.35,31.35,0,0,1,218,91.19c7.25-4.44,18.23-1.61,18.23-1.61a14.2,14.2,0,0,1,9.58-2.64A10.9,10.9,0,0,1,254,91.72s3.36-2.48,11.5-2,10.09,6.9,10.09,6.9a19.78,19.78,0,0,1,11.34,3.19c6,3.73,6,11.7,6,11.7s7.27-2,13.64,4.61,3.56,12.76,3.56,12.76a14.39,14.39,0,0,1,11.33,21.25,6.4,6.4,0,0,1,4.07,3.9c1.24,3.19,0,5.14,0,5.14s6.19,2.64,7.8,9.2-1.61,10.45-1.61,10.45a10.21,10.21,0,0,1,5.14,9.22C336.89,194.82,329.81,196.23,329.81,196.23Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81,196.23s3.34,3.33,1,9.49c-2.23,6-9.53,7-9.53,7s1,9.81-14.92,11a10,10,0,0,0,0-2.06s7.31-.29,7.42-11.64-8.4-13.1-8.4-13.1a10.41,10.41,0,0,0,1.32-9.12c-2.08-6.22-6.48-5.56-6.48-5.56s3.19-2.34,1.79-8.14c-1.3-5.39-5.35-6.09-5.35-6.09s3-5.36-2.47-12.6-11.09-6.12-11.09-6.12a16.31,16.31,0,0,0-3.88-9.7c-3.89-4.53-10-3.89-10-3.89A15.79,15.79,0,0,0,264,123.52c-5.82-5.5-11.66-5.25-11.66-5.25a9.32,9.32,0,0,0-3.93-8.11,10.71,10.71,0,0,0-10.54-1.51s-1-7.12-7.16-8.48c-8.05-1.76-12,3-12,3a11.05,11.05,0,0,0-2.67-2.27c-.17-.11-.32-.2-.51-.3a15.9,15.9,0,0,0-5.63-2A31.35,31.35,0,0,1,218,91.19c7.25-4.44,18.23-1.61,18.23-1.61a14.2,14.2,0,0,1,9.58-2.64A10.9,10.9,0,0,1,254,91.72s3.36-2.48,11.5-2,10.09,6.9,10.09,6.9a19.78,19.78,0,0,1,11.34,3.19c6,3.73,6,11.7,6,11.7s7.27-2,13.64,4.61,3.56,12.76,3.56,12.76a14.39,14.39,0,0,1,11.33,21.25,6.4,6.4,0,0,1,4.07,3.9c1.24,3.19,0,5.14,0,5.14s6.19,2.64,7.8,9.2-1.61,10.45-1.61,10.45a10.21,10.21,0,0,1,5.14,9.22C336.89,194.82,329.81,196.23,329.81,196.23Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,195.91a12.17,12.17,0,0,0,.4-8.71c-1.19-3.55-3.19-5.38-5.06-6.24a11.11,11.11,0,0,0,.42-7.3,9.88,9.88,0,0,0-4.81-6.72c.61-2.52.81-7.17-3.35-12.67s-8.42-6.67-10.89-6.89a18.51,18.51,0,0,0-4.15-9,13.75,13.75,0,0,0-9.59-4.53,18.06,18.06,0,0,0-5.72-11.69,20.55,20.55,0,0,0-11.11-5.63,11.3,11.3,0,0,0-4.65-7.87,12.65,12.65,0,0,0-10.31-2.37c-.87-2.61-3-6.82-8.12-7.94-6.18-1.36-10.3.71-12.35,2.24a17.12,17.12,0,0,0-7.5-3.62,36.09,36.09,0,0,0-2.67,3.39c5.86.63,8.44,3.78,8.58,4a1.9,1.9,0,0,0,1.45.74,1.93,1.93,0,0,0,1.49-.65c.14-.16,3.45-3.86,10.19-2.37,4.78,1,5.68,6.66,5.71,6.89a1.91,1.91,0,0,0,2.67,1.45,8.79,8.79,0,0,1,8.61,1.32,7.45,7.45,0,0,1,3.19,6.37,1.9,1.9,0,0,0,.49,1.49,1.7,1.7,0,0,0,1.45.62c.19,0,5.18-.09,10.29,4.73a13.94,13.94,0,0,1,4.57,10.64,1.91,1.91,0,0,0,.54,1.52,1.93,1.93,0,0,0,1.53.55c.05,0,5.23-.46,8.39,3.22a14.61,14.61,0,0,1,3.42,8.47,1.9,1.9,0,0,0,.69,1.44,1.94,1.94,0,0,0,1.54.42c.19,0,4.63-.69,9.25,5.4s2.42,10.4,2.33,10.56a1.91,1.91,0,0,0-.05,1.71,1.94,1.94,0,0,0,1.36,1.07c.12,0,2.89.63,3.85,4.66,1.06,4.39-1,6.12-1.07,6.17a1.86,1.86,0,0,0-.62,2.2,1.92,1.92,0,0,0,2,1.2c.29,0,3-.16,4.44,4.27a8.49,8.49,0,0,1-1,7.4,1.9,1.9,0,0,0-.27,1.8,1.93,1.93,0,0,0,1.37,1.2c.29.06,7,1.66,6.92,11.22-.1,9.28-5.42,9.75-5.62,9.77a1.91,1.91,0,0,0-1.79,2.17,8.69,8.69,0,0,1,0,1.47,4.75,4.75,0,0,0,1.87.31c.67,0,1.28-.14,1.9-.22,0-.12,0-.26,0-.37,2.67-.92,7.26-3.85,7.36-13.09C315.75,201.85,311.53,197.63,308.07,195.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,221.67s7.31-.29,7.43-11.64-8.41-13.09-8.41-13.09a10.46,10.46,0,0,0,1.31-9.14c-2.06-6.21-6.47-5.55-6.47-5.55s3.19-2.34,1.79-8.14c-1.3-5.4-5.35-6.08-5.35-6.08s3-5.38-2.48-12.62-11.09-6.12-11.09-6.12a16.36,16.36,0,0,0-3.87-9.7c-3.88-4.52-10-3.87-10-3.87a15.89,15.89,0,0,0-5.15-12.2c-5.82-5.5-11.65-5.25-11.65-5.25a9.35,9.35,0,0,0-3.94-8.11,10.69,10.69,0,0,0-10.53-1.51s-1-7.12-7.18-8.48c-8-1.77-12,3-12,3s-5.44-7.2-18.54-4c-11,2.67-11.78,10.89-11.78,10.89s-11.28-2.11-16.45,5.64-3.56,17.77-3.56,17.77-6.46,4.53-6.14,11.31a20.55,20.55,0,0,0,3.24,10.67s-6.47,11-1.94,20a21,21,0,0,0,12.6,11s0,9.69,4.52,14.54,12.6,4.52,12.6,4.52a17.42,17.42,0,0,0,8.73,10c6.78,3.23,13.89.64,13.89.64a17.48,17.48,0,0,0,8.08,5.5c5.17,1.61,11.63,0,11.63,0a8.33,8.33,0,0,0,6.79,6.78c6.14,1.29,9.37-2.58,9.37-2.58s1.94,4.2,6.46,4.52a9.06,9.06,0,0,0,7.11-2.58s2.59,8.07,13.25,8.4,13.28-4.28,13.28-4.28,5.14,3.64,10.31-.24A11.07,11.07,0,0,0,306.34,221.67Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,221.67s7.31-.29,7.43-11.64-8.41-13.09-8.41-13.09a10.46,10.46,0,0,0,1.31-9.14c-2.06-6.21-6.47-5.55-6.47-5.55s3.19-2.34,1.79-8.14c-1.3-5.4-5.35-6.08-5.35-6.08s3-5.38-2.48-12.62-11.09-6.12-11.09-6.12a16.36,16.36,0,0,0-3.87-9.7c-3.88-4.52-10-3.87-10-3.87a15.89,15.89,0,0,0-5.15-12.2c-5.82-5.5-11.65-5.25-11.65-5.25a9.35,9.35,0,0,0-3.94-8.11,10.69,10.69,0,0,0-10.53-1.51s-1-7.12-7.18-8.48c-8-1.77-12,3-12,3s-5.44-7.2-18.54-4c-11,2.67-11.78,10.89-11.78,10.89s-11.28-2.11-16.45,5.64-3.56,17.77-3.56,17.77-6.46,4.53-6.14,11.31a20.55,20.55,0,0,0,3.24,10.67s-6.47,11-1.94,20a21,21,0,0,0,12.6,11s0,9.69,4.52,14.54,12.6,4.52,12.6,4.52a17.42,17.42,0,0,0,8.73,10c6.78,3.23,13.89.64,13.89.64a17.48,17.48,0,0,0,8.08,5.5c5.17,1.61,11.63,0,11.63,0a8.33,8.33,0,0,0,6.79,6.78c6.14,1.29,9.37-2.58,9.37-2.58s1.94,4.2,6.46,4.52a9.06,9.06,0,0,0,7.11-2.58s2.59,8.07,13.25,8.4,13.28-4.28,13.28-4.28,5.14,3.64,10.31-.24A11.07,11.07,0,0,0,306.34,221.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.16,129.43a32.18,32.18,0,0,0-4-6c-1.15-1.31-3-3.25-4.89-3-.56.06-.2,1,.2,1,1.75.31,3,1.8,3.94,3.17a39.52,39.52,0,0,1,2.76,4.65A32,32,0,0,1,223,142.91c.16,4-.82,8.09-4.65,10.07-4.49,2.32-10.29.85-14.52-1.31a11.84,11.84,0,0,1-6.73-9c-.07-.5-.85-.92-.83-.19a12.08,12.08,0,0,0,1.56,6.17,12.69,12.69,0,0,0,4.59,4.17c4.34,2.54,9.6,4,14.59,2.71C228.7,152.55,225.35,137.2,221.16,129.43Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.49,135.63a10.8,10.8,0,0,0-1.61-4.58,14.68,14.68,0,0,0-3.19-3.7,11.55,11.55,0,0,0-4.32-2.51c-.69-.18-.64.79-.22,1.06a25.2,25.2,0,0,1,3.69,2.46,13.49,13.49,0,0,1,2.71,3.4,10.07,10.07,0,0,1,1.18,3.93,10.22,10.22,0,0,1-.07,2.21c-.1.7-.28,1.36-.39,2.06-.05.32.36,1,.72.64A6.37,6.37,0,0,0,208.49,135.63Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.19,112.11a32.09,32.09,0,0,0-10.91-1,19.85,19.85,0,0,0-9.67,3.39c-5.09,3.37-8.91,8.38-9.87,14.49-.53,3.37-.82,7.59,2.16,10,.36.28,1,.12.81-.43a14.07,14.07,0,0,1-1.16-6,26.91,26.91,0,0,1,.8-5.2,18.88,18.88,0,0,1,5.66-8.94A20.23,20.23,0,0,1,202.16,113a26.47,26.47,0,0,1,6.1-.15,33.71,33.71,0,0,0,6.1.29C214.91,113.11,214.54,112.21,214.19,112.11Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M191.47,149.78c-3.06-4.91-8.86-8.83-14.75-8.71-4.62.09-11.74,2.67-11.08,8.44a10.35,10.35,0,0,0,4.5,7.11,3.76,3.76,0,0,0,3.71.21c1.38-.79,1.52-2.53,1.89-3.9.06-.22-.19-.71-.44-.44-1.14,1.22-2.25,4.22-4.36,2.73a9.13,9.13,0,0,1-3.3-5.24c-.83-4.45,4.31-6.6,7.85-7.1,4.93-.71,9.46,1.89,12.67,5.46,2.08,2.32,4.82,7.13,1.44,9.53a5.14,5.14,0,0,1-3.84.9c-1.56-.3-1.71-1.5-2-2.86-.15-.67-1.36-.95-1.59-.21a3.58,3.58,0,0,0,1.89,4.23,6.64,6.64,0,0,0,5.05.24,5.88,5.88,0,0,0,3.78-3.27C193.77,154.59,192.7,151.76,191.47,149.78Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M236.91,205.69c-2.58-5-7.4-8.39-12.36-10.69-.83-.38-1.66-.74-2.5-1.07a14.4,14.4,0,0,0,2.53-3,25.62,25.62,0,0,0,3.29-7.12,8.72,8.72,0,0,0-.94-7.31,7.82,7.82,0,0,0-2.81-2.58c-1.13-.6-3.05-1.26-4.3-.69-.5.23.06,1,.39,1.05,1.29.31,2.42.32,3.55,1.13a5.75,5.75,0,0,1,2.05,2.82,8.85,8.85,0,0,1-.24,5.79,25.28,25.28,0,0,1-2.83,5.82,12.81,12.81,0,0,1-2,2.4,6.15,6.15,0,0,1-1.19.79c-4.26-1.49-8.66-2.6-13-4-6.25-2-12-5.07-16.38-10a21.47,21.47,0,0,1-5.47-10.31,22.4,22.4,0,0,1-.3-4.91c.06-1.34.17-3.11,1.16-4.13.47-.49-.43-1.48-1-1.12-2.07,1.34-2,4.67-2,6.86a20.28,20.28,0,0,0,2.48,9.91,33,33,0,0,0,14.62,13.41c10.38,5,23.59,5.07,32,13.79a16,16,0,0,1,4.47,8.12,12.88,12.88,0,0,1,0,5.1c-.35,1.59-1.36,2.73-1.87,4.21-.14.39.42,1.09.84.88,2.45-1.17,3.31-4.49,3.49-7A15.7,15.7,0,0,0,236.91,205.69Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.85,206.28c-2.84-2.05-6.31-2.56-9.64-3.32s-6.67-1.44-9.94-2.43a42.85,42.85,0,0,1-4.79-1.75c-2.24-1-4.19-2.43-6.39-3.42a.48.48,0,0,0-.67.63c.66,1.41,2.35,2.45,3.64,3.24a25.5,25.5,0,0,0,4.06,2,63.28,63.28,0,0,0,9.16,2.69c3.74.86,7.8,1.29,11.4,2.62a12.09,12.09,0,0,1,3.09,1.7c1.14.84,2.81,2.15,2.93,3.66,0,.49.88.94,1,.25C228,209.63,225.74,207.65,223.85,206.28Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.47,178.62a19.64,19.64,0,0,0-3.85-5c-2-2.19-3.47-4.49-3.46-7.6a26.51,26.51,0,0,1,.63-4.86c.31-1.65.84-3.55.19-5.16-.11-.28-.51-.51-.7-.18a7.71,7.71,0,0,0-.58,2.43c-.13.76-.27,1.5-.42,2.25a35.56,35.56,0,0,0-.72,4.47,11,11,0,0,0,2.27,7.58c1.27,1.66,2.84,3.05,4.09,4.73a6.86,6.86,0,0,1,1.27,2.53c.36,1.56-.17,3-.52,4.52,0,.23.19.92.52.62A5.47,5.47,0,0,0,178.47,178.62Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M294.67,169.32a20,20,0,0,0-4.32,2,14.06,14.06,0,0,1-5,1.37c-3.1.24-6.11-.77-9.2-.75a9.49,9.49,0,0,0-7.17,3.17,11.94,11.94,0,0,0-1.78,2.45c-.62-.69-1.27-1.37-1.95-2a25.73,25.73,0,0,0-8.84-5.4,55.06,55.06,0,0,0-11.31-2.35c-3.46-.46-6.81-.9-10-2.49-2.62-1.32-5.67-3.17-6.46-6.21-.14-.51-1-.67-.9,0,.22,2.62,2.18,4.6,4.15,6.14a19.43,19.43,0,0,0,7.36,3.55c7,1.65,14.46,1.46,20.67,5.53a23,23,0,0,1,10.35,15.22c.93,5.27,1.34,11.85-2.82,15.89a44.58,44.58,0,0,1-9.84,6.93c-.83.45-1.74,1-2.62,1.55a23.74,23.74,0,0,0,.95-4.82,25.07,25.07,0,0,0-.84-9.94,22.59,22.59,0,0,0-4.73-8.21c-2.52-2.82-5.66-4.68-8.68-6.9a21,21,0,0,1-4.73-4.59c-1.5-2-2.75-4.3-4.08-6.45-.26-.42-.56.13-.42.44,1.52,3.38,3,6.78,5.55,9.54s5.81,4.55,8.55,7A22.35,22.35,0,0,1,254,206.64a21.15,21.15,0,0,1-.7,6c-.36,1.33-.91,2.6-1.31,3.91a6.1,6.1,0,0,0-1.36,2.88c-.08.5.78,1.27,1.19.76a22.62,22.62,0,0,1,3.52-3.73,26.83,26.83,0,0,1,4-2.44,46.29,46.29,0,0,0,9-6.18,13.53,13.53,0,0,0,4.52-7.16,25.39,25.39,0,0,0,.35-8.65,27.64,27.64,0,0,0-2-8.46,23.11,23.11,0,0,0-2.22-3.78,8.92,8.92,0,0,1,.62-1.62,10.4,10.4,0,0,1,2.27-2.59c2.09-1.74,4.85-1.57,7.39-1.23,2.92.4,5.82.8,8.72,0a17.84,17.84,0,0,0,4.1-1.67,10.66,10.66,0,0,0,3.27-2.39C295.61,169.93,295.12,169.22,294.67,169.32Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M285.51,158.37c-1.71-4.05-6.16-5.76-10-7.13a56.14,56.14,0,0,1-12.38-5.67,20.86,20.86,0,0,1-4.81-4.27,18.05,18.05,0,0,1-3.5-9.23c-.07-.54-1.31-1.1-1.45-.35-1.55,8.33,5.32,14.32,12,17.74,3.59,1.84,7.4,3,11.15,4.4,3.05,1.17,7.8,3.52,7.13,7.58-.32,2-2.14,2.59-3.85,3a28,28,0,0,1-7,.58,66.61,66.61,0,0,1-14.36-2.32,34.12,34.12,0,0,1-20.83-15.48,32.55,32.55,0,0,1-4.42-14.64,35.29,35.29,0,0,1,.4-7.68c.45-3,1-6.26,2.75-8.83.11-.17,0-.68-.28-.46a11.55,11.55,0,0,0-2.88,5.81,52.9,52.9,0,0,0-1.31,6.84,32.12,32.12,0,0,0,1.8,15.2,35.67,35.67,0,0,0,18.75,19.31,58.49,58.49,0,0,0,13.8,3.56c5,.8,10.28,1.15,15.2-.21a6.11,6.11,0,0,0,4.17-3A5.76,5.76,0,0,0,285.51,158.37Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M269,157.75c-1.78-.61-3.72-.8-5.52-1.39a39.28,39.28,0,0,1-5.37-2.09,24.43,24.43,0,0,1-8.08-6.55A24,24,0,0,1,245,137.47c-.73-4,.37-7.84.59-11.8,0-.33-.56-1.14-.8-.55a24.41,24.41,0,0,0-1.68,13.63,24.66,24.66,0,0,0,5.4,10.52,23.37,23.37,0,0,0,9,6.84,36,36,0,0,0,6,1.81c1.68.36,4,1.07,5.69.58C269.47,158.41,269.31,157.84,269,157.75Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M299.08,190.6c-3.81-3.56-10.69-4.62-11.9-10.51-.08-.36-.77-.75-.83-.18-.43,4.91,5.4,8,8.94,10.15a11,11,0,0,1,4.81,5.43c1.16,2.85.75,5.52-.23,8.33-.11.34.28.88.63.64C305.26,201.17,302.44,193.74,299.08,190.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M307.8,212c-2.05,1.83-4.08,3.23-6.9,3.35a13.55,13.55,0,0,1-6.88-1.66,7.44,7.44,0,0,1-4.3-5.69,12,12,0,0,1,.26-4.47,25.11,25.11,0,0,0,.91-4.35l.2.15a12,12,0,0,1,2.79,3.94c.12.21.62.52.8.18.86-1.61-.39-3.34-1.53-4.46a20.56,20.56,0,0,0-4.1-3,42.86,42.86,0,0,1-4.81-3.16,20.1,20.1,0,0,1-2.16-2c-1-1.05-1.73-2.25-2.65-3.33-.17-.2-.39,0-.38.22.11,1.91,1.76,3.79,3.05,5.07a27.19,27.19,0,0,0,4.93,3.73c.79.48,1.57,1,2.34,1.49a.74.74,0,0,0-.32.48c-.29,1.48-.85,2.9-1.23,4.35a13.64,13.64,0,0,0-.45,4.22,8.87,8.87,0,0,0,2.51,6.17,15.64,15.64,0,0,0,12.76,3.82,9.65,9.65,0,0,0,3.4-1.23,4.93,4.93,0,0,0,2.53-3.26C308.66,212.22,308.16,211.64,307.8,212Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M292.68,227.83a6.79,6.79,0,0,0-.59-2,19.16,19.16,0,0,0-2.27-3.82,10.58,10.58,0,0,0-3.53-2.84,12.78,12.78,0,0,0-2.13-.89l-.43-.14a6.68,6.68,0,0,0,.45-2,19.54,19.54,0,0,0-.8-6.4c-.57-2.05-1.49-4.17-3.54-5.11-.82-.38-.86.8-.29,1.16.88.55,1.33,2.24,1.63,3.16a19.4,19.4,0,0,1,.8,3.67c.22,1.82.39,3.79-.44,5.43a.31.31,0,0,0-.14.26,5.35,5.35,0,0,1-.34.54c-1.64,2.1-4.37,3-6.68,4.16s-4.86,2.5-5.21,5.24c-.06.43.61,1.05,1,.6a16,16,0,0,1,5.78-4.46,23.49,23.49,0,0,0,5.86-3.35,7.77,7.77,0,0,0,1.2-1.39l.16,0,.85.26a12.5,12.5,0,0,1,1.65.69,8.54,8.54,0,0,1,2.68,2.13A20.75,20.75,0,0,1,289.9,225a15.61,15.61,0,0,1,.92,1.71,13.64,13.64,0,0,1,.68,1.61,4,4,0,0,0,.36.94c.08.11.24.3.4.22C292.83,229.21,292.73,228.36,292.68,227.83Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M276,207.72c0-.32-.48-.69-.58-.18a9.07,9.07,0,0,1-2.28,4.76,24,24,0,0,1-4,3.19,22.23,22.23,0,0,0-3.9,3.2,7.69,7.69,0,0,0-1.46,2.16,4.09,4.09,0,0,0-.18,2.63c0,.18.33.68.57.41a22.22,22.22,0,0,0,1.8-2.8,10.2,10.2,0,0,1,1.6-1.93,34.78,34.78,0,0,1,3.74-2.85,13.56,13.56,0,0,0,3.66-3.46A7.56,7.56,0,0,0,276,207.72Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M224.65,166.75a13.81,13.81,0,0,0-4.37-1.26,36.85,36.85,0,0,0-13.15.7A45.74,45.74,0,0,0,197,169.43a24.82,24.82,0,0,0-4.77,2.86c-1,.77-3,2.2-2.43,3.65.09.23.36.55.64.47,1.45-.42,2.57-2,3.78-2.86a22.93,22.93,0,0,1,4.08-2.34,44.41,44.41,0,0,1,8.86-2.91,42.21,42.21,0,0,1,11.41-1.22,26,26,0,0,1,3.94.46,8.84,8.84,0,0,1,3.5,1.66.27.27,0,0,0,.4-.07C226.87,168,225.46,167.18,224.65,166.75Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M203.67,157.65a5.15,5.15,0,0,0-1.53,1.22c-.56.54-1.13,1-1.72,1.54a18.89,18.89,0,0,1-3.94,2.5,16.76,16.76,0,0,1-4.21,1.32,20.26,20.26,0,0,1-2.06.22,6.66,6.66,0,0,0-2,.16c-.5.18-.22.86.11,1.06,1.3.79,3.38.48,4.8.24a16.63,16.63,0,0,0,4.6-1.54,19.34,19.34,0,0,0,3.94-2.63,15.34,15.34,0,0,0,1.7-1.72,2.74,2.74,0,0,0,.9-1.79C204.31,157.93,204,157.51,203.67,157.65Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M277.29,99.49c-.17-.19-.37,0-.4.18-.19,1,0,2-.13,3a11.56,11.56,0,0,1-1.18,3.85c-1.18,2.33-3.18,4.7-5.76,5.5-6.35,2-11.79-2.17-16.19-6.22a24.22,24.22,0,0,0-.89-2.38,21.39,21.39,0,0,0-3.61-5.49,34.94,34.94,0,0,0-4.43-4.34A13.39,13.39,0,0,0,242,91.81a4.26,4.26,0,0,0-2.59-.61c-.51.11-.26.88.14,1a10.3,10.3,0,0,1,4.25,2.7,43.69,43.69,0,0,1,3.74,4,18.93,18.93,0,0,1,3.24,5.08,18,18,0,0,1,1,3.45c.1.53.19,1.06.3,1.58a9.34,9.34,0,0,0,.76,1.89c.11.25.49.53.67.19a5,5,0,0,0,.54-2.41,17.12,17.12,0,0,0,5.46,4.15A15.45,15.45,0,0,0,270.16,114a11.33,11.33,0,0,0,6.61-5.31C278.36,106,279.54,102.1,277.29,99.49Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M291.15,120.81c-2.24-1.69-5.11-3.25-8-3.17-.57,0-.17,1.06.28,1.09,2,.17,4.23,1.49,5.85,2.67,1.35,1,3.45,2.68,3.4,4.56-.05,2.63-4.56,3.06-6.4,3a18.13,18.13,0,0,1-9.8-3.68,19.87,19.87,0,0,1-4-3.58c-1.34-1.62-1.91-3.57-2.86-5.42-.15-.28-.71-.54-.76,0a10.36,10.36,0,0,0,2,6.36,17.73,17.73,0,0,0,4.21,4.3,19.92,19.92,0,0,0,11.28,4.14c2.79.06,7.81-.92,8.46-4.28C295.25,124.31,292.9,122.14,291.15,120.81Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4,148.63c-1.19-.34-2.65.12-3.85.3-1.43.22-2.86.46-4.3.61a26.14,26.14,0,0,1-8.51-.37,20.8,20.8,0,0,1-6.51-2.66,27.64,27.64,0,0,1-6-5.6c-.31-.35-.75-.2-.73.27a7.25,7.25,0,0,0,1.57,3.49,12.76,12.76,0,0,0,2.69,2.75,21.28,21.28,0,0,0,7.31,3.45,26.19,26.19,0,0,0,9.16.76,48.61,48.61,0,0,0,5.1-.76c.87-.16,1.72-.37,2.58-.56.58-.13,1.54-.17,1.89-.73A.66.66,0,0,0,319.4,148.63Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M310.53,134.1c-.61,0-.12,1,.23,1.06,1.59.44,2.07,3.83,1.37,5.17-1.05,2-4.3,2.08-6.23,2.1a17.84,17.84,0,0,1-8.91-2.31c-2.57-1.47-4.63-3.6-7.1-5.2-.42-.26-.52.37-.31.63,2.32,2.75,4.73,5.53,8,7.1a19.22,19.22,0,0,0,11,1.57c2.47-.37,5.47-1.46,5.72-4.35C314.57,137.58,313.26,134,310.53,134.1Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M322.58,158.15a2.59,2.59,0,0,0-.38-.17,5.66,5.66,0,0,0-.59-.15,7.42,7.42,0,0,0-1.14-.15,11.64,11.64,0,0,0-2.5.16,22,22,0,0,0-5.38,1.62,10,10,0,0,0-3.8,2.75,9.6,9.6,0,0,0-1.68,5.39,6.76,6.76,0,0,0,.77,3.76,6,6,0,0,0,5,3,.92.92,0,0,0,.49-.13.62.62,0,0,0,.1-.73,1.92,1.92,0,0,0-.54-.56,11.17,11.17,0,0,1-2.45-2.35,6.27,6.27,0,0,1,2-8.72,19.71,19.71,0,0,1,5-1.94,9.32,9.32,0,0,1,5.74,0,.37.37,0,0,0,.4-.4C323.71,159.18,322.85,158.28,322.58,158.15Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M327.25,181.05c-2-4.3-6.84-6.94-11.37-7.7-2.47-.42-6.78-.6-8.39,1.74a.73.73,0,0,0-.17.44.57.57,0,0,0,.45.49,1.56,1.56,0,0,0,.71,0c2-.37,3.77-1,5.86-.84a14,14,0,0,1,10,5.5c1.68,2.49,2.12,6.61.22,9.13-1.63,2.15-4.6,2.16-7,1.51a7.38,7.38,0,0,1-3.65-1.92c-.85-1-.26-2.09.47-3,.38-.46-.31-1.48-.86-1.12-1.64,1.06-3,2.8-1.88,4.76a7.1,7.1,0,0,0,3.73,2.73c3.26,1.26,7.25,1.56,10.14-.78C328.6,189.51,328.82,184.43,327.25,181.05Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M322.72,202a11.56,11.56,0,0,0-3.09-4,5.92,5.92,0,0,0-4.56-1.51c-.55.1-.21,1,.23,1,2.83.21,4.72,2.94,5.68,5.34a12.11,12.11,0,0,1,.86,3.75,10.44,10.44,0,0,1-.06,1.85c0,.22-.08.44-.11.66a4.06,4.06,0,0,0-.11,1.29c.08.35.36.73.76.58.67-.27,1.15-1.31,1.36-1.94a6.89,6.89,0,0,0,.27-2.43A11.73,11.73,0,0,0,322.72,202Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.24,125.3c-.7-.12-1.39.32-1.78,1.59-.9,2.86,0,7.6.29,10.52a79.42,79.42,0,0,0,2.1,12.44c.84,3.31,1.94,6.66,4.14,9.27a19.76,19.76,0,0,0,7.94,5.26c8.11,3.25,17.24,3.74,25,7.81,1,.5,2.17,1,3,.35a1.77,1.77,0,0,0,.21-2.22,4.34,4.34,0,0,0-1.88-1.49c-3.09-1.51-6.53-2.08-9.85-3A40.07,40.07,0,0,1,241,158.2,28.15,28.15,0,0,1,231.64,144c-.93-3.55-1-7.24-1.53-10.86-.27-1.91-.14-4.06-.91-5.86A3.09,3.09,0,0,0,227.24,125.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.26,139.56a7.2,7.2,0,0,1-6.31,6.25,2.48,2.48,0,0,0-1.71.49c-.77.84.25,2.11,1.19,2.75,3.12,2.13,6.87,4.12,10.51,3.13,3.81-1,6.14-5.15,6.31-9.1.15-3.31-2-20.7-8.76-15.41C208.32,130.16,210.65,136.23,210.26,139.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,139.32c2.55-8.88-14-18.81-14.59-7.31a8.1,8.1,0,0,0,.72,4.42c2.52,4.47,6.79-2.48,10.31,1.86a10.16,10.16,0,0,0,1.32,1.65,1.44,1.44,0,0,0,1.92.06A1.71,1.71,0,0,0,203.12,139.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.47,178.51a7.79,7.79,0,0,0,2,1.81c6.93,5,12.81,12.3,13.52,20.81.15,1.83.32,4.1,2,4.8a3.66,3.66,0,0,0,3.05-.44c3.24-1.78,5.07-5.53,5.29-9.22a22.14,22.14,0,0,0-2.53-10.68C263.67,181,260,177,255,175.65,252.9,175.11,239.09,173.44,242.47,178.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.29,176.83c2.08.3,4.14,1.7,6.32,1.93,2.69.29,5.84,0,8.1-1.59a24.68,24.68,0,0,1,2.28-1.83,4.49,4.49,0,0,1,5.24,1.08,7.44,7.44,0,0,1,1.75,5.35,7.71,7.71,0,0,1-3,6.19c-2.6,1.78-6.11,1.12-9.12.22-4.78-1.43-9.52-3.35-13.29-6.61a5.21,5.21,0,0,1-1.54-1.89,2.12,2.12,0,0,1,.35-2.3,2.83,2.83,0,0,1,1.78-.6A5.79,5.79,0,0,1,199.29,176.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,151c4.14,4.6,9.83,7.53,15.61,9.74,5.5,2.11,14.14,5.18,20,2.71,1.8-.76,3.31-2.59,3.05-4.52s-1.92-3.14-3.56-4c-5.81-3.13-12.51-4.38-18.4-7.34-1.13-.57-2.67-1.08-3.53-.15s-.31,2.32.57,3.11a21,21,0,0,0,4.69,3.17c2.21,1,6.6,1.36,8.33,3s.24,2.82-1.84,2.51c-5.83-.88-11.66-2.5-16.58-5.75a22.72,22.72,0,0,1-9-11,31.78,31.78,0,0,1-1.45-5.1c-.18-1,.2-3.81-.71-4.52-2.87-2.26-2.57,6.6-2.38,7.72A21.08,21.08,0,0,0,242.53,151Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.43,106.62a8.36,8.36,0,0,0-7.34-3.29,14.06,14.06,0,0,0-7.66,3.15,18.09,18.09,0,0,0-14.25-3.93c-3.76.54-7.66,2.23-10,5.41-.43.6-.76,1.53-.18,2a1.53,1.53,0,0,0,.87.25c3.91.18,7.83-1.6,11.9-1.52a23.65,23.65,0,0,1,12.1,3.24c2.34,1.45,4.39,3.43,7,4.39A6.44,6.44,0,0,0,232.43,106.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,117.26a18.63,18.63,0,0,0-4.13,11.33c-.07,4.48,1.83,8.18,6.82,8.21a3,3,0,0,0,1.4-.26c1.36-.72,1.26-2.65,1.12-4.18a21.91,21.91,0,0,1,3-13.11c.66-1.11,1.46-2.36,1.09-3.6a2.88,2.88,0,0,0-2.4-1.82C179.68,113.41,177.3,115.16,175.6,117.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84,212.83a29.51,29.51,0,0,0-.65-10.41,21.45,21.45,0,0,0-8.26-12.53c-2.13-1.52-6.36-4-8.92-2.2s-1.84,5.28-.3,7.38,3.87,3.55,5.58,5.55a16.67,16.67,0,0,1,3.6,9.13c.31,2.94-.69,5.45-.59,8.23a3.07,3.07,0,0,0,1.22,2.49,3.11,3.11,0,0,0,1.76.45,6.26,6.26,0,0,0,5-3.33A13.19,13.19,0,0,0,249.84,212.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.61,197.08l14.09,4.68a36,36,0,0,1,7.73,3.25,12.07,12.07,0,0,1,5.32,6.28c.42,1.29.73,2.9,2,3.35a2.39,2.39,0,0,0,2.82-1.73,5.4,5.4,0,0,0-.47-3.58c-2.45-5.88-8.11-9.84-14-12.3s-12.18-3.77-18.06-6.23a49.79,49.79,0,0,1-15.77-10.53c-2.11-2.09-4.42-2.47-4.2,1.14C181.69,191,194.16,194.61,201.61,197.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.18,182.06c-1.51-1.94-3.5-.47-3.58,2.24s1.95,5.22,4.22,6.83,4.91,2.71,7,4.53a17,17,0,0,1,2.86,3c1,1.48,1.57,6.22,4.3,3.56,1.95-1.89.93-6.28-.38-8.14-1.62-2.29-4.14-3.73-6.58-5.11-2.59-1.47-6-3.37-7.39-6.09A6.47,6.47,0,0,0,284.18,182.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,216.79a11.45,11.45,0,0,1-6.63-6.21c-.18-.45-.52-1-1-.89s-.43.71-.36,1.14c.26,1.65.29,3.46,1.13,4.92a15.82,15.82,0,0,0,3.57,4,9.89,9.89,0,0,1,2.75,3.32c.6,1.36.51,2.91,1.39,4.18a4.19,4.19,0,0,0,1.86,1.46,5.5,5.5,0,0,0,7-3.06C305.13,219.23,297.63,218.53,293,216.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.06,144.55a7.84,7.84,0,0,0-3,.47,3.24,3.24,0,0,0-2,2.15,3.55,3.55,0,0,0,2,3.58,18.34,18.34,0,0,0,4.21,1.29,16,16,0,0,1,6.24,3.28c.79.67,1.78,1.48,2.74,1.07a2.27,2.27,0,0,0,1.06-2.09,7.91,7.91,0,0,0-1-4.36C185.18,146.14,181.18,144.53,177.06,144.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.2,98.13c2.22,3,4.09,6.28,6.89,8.72s6.92,3.85,10.28,2.26a7.67,7.67,0,0,0,4.09-5.61c.53-3.18-1-7.65-3.7-9.47a10.48,10.48,0,0,0-11.86.4,1.76,1.76,0,0,1-.8.44,1.69,1.69,0,0,1-1-.35c-1.78-1.1-5.78-4.79-8-4C244,91.54,250.37,97,251.2,98.13Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.84,112.59a1.07,1.07,0,0,0-.09.85,1,1,0,0,0,.73.42c1.92.46,3.88.71,5.79,1.23a21.28,21.28,0,0,1,9.56,5.64,10.31,10.31,0,0,1,3.29,6.34c.14,2.43-1.41,5.06-3.8,5.48-.38,1.22.78,2.34,1.85,3a32.11,32.11,0,0,0,5.43,2.81c2.1.84,4.93,1.26,6.24-.58,1-1.37.48-3.37-.66-4.6a11.09,11.09,0,0,0-4.33-2.46c2.91-3.14,2.81-8.39.28-11.84s-7-5.12-11.31-4.86a4.12,4.12,0,0,1-2.49-.31c-1.57-1-.82-3.41-.91-4.94-.17-2.74-2.23-6.89-5.5-4.74C280.34,105.76,279.93,110,278.84,112.59Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,119.35a2.24,2.24,0,0,0-2.11.78c-.48.85.23,1.88,1,2.53a15.13,15.13,0,0,0,3.33,2.28,15.4,15.4,0,0,0,7.83,1.62,2.48,2.48,0,0,0,1-.22c2.44-1.33-.44-5.37-2.09-6C283.42,119.31,279.71,119.4,277,119.35Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.25,152.81a1.84,1.84,0,0,0-1.5.25,1.29,1.29,0,0,0-.11,1.56c.63,1.1,1.65,2,2.32,3.14a9,9,0,0,1,1.3,4.58c0,1.29-.26,2.67.38,3.79.35.6.93,1.05,1.24,1.66.19.37.28.79.47,1.16a1.18,1.18,0,0,0,.95.71c.66,0,1-.76,1.18-1.4.61-2.32.56-5,1.6-7.16,1.17-2.45,3.36-3.15,5.66-4,2.66-1.05,5.53-1.22,8.29-1.89a3.34,3.34,0,0,0,1.07-.43,1.14,1.14,0,0,0,.51-1c-.16-1.33-2.83-1-3.66-.9A67.74,67.74,0,0,1,299.25,152.81Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,169.6c0-3.78,5.21-6.43,8.47-6.45a12.88,12.88,0,0,1,7,2.29c2.62,1.72,3.59,6,2.91,8.92a4.57,4.57,0,0,1-1.27,2.39,2.34,2.34,0,0,1-2.54.46,4.09,4.09,0,0,1-1.27-1.25,13.55,13.55,0,0,0-10-5C314.8,170.89,313.18,170.8,312.79,169.6Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,178.5a12.42,12.42,0,0,0-6.09-.86,3.89,3.89,0,0,0-2.2.81,1.66,1.66,0,0,0-.38,2.14,2.48,2.48,0,0,0,.91.68,38.85,38.85,0,0,1,4.83,3.1,3.86,3.86,0,0,1,1.37,1.5,12.5,12.5,0,0,0,.56,1.95,3.1,3.1,0,0,0,2.34,1.07,3.35,3.35,0,0,0,1.78-.08,2.71,2.71,0,0,0,1.29-1.95,7.22,7.22,0,0,0-7.09-8.84",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,130.58a1.11,1.11,0,0,0-1,.14.74.74,0,0,0,0,.93,2.24,2.24,0,0,0,.84.57,35,35,0,0,1,6.66,3.59,9.63,9.63,0,0,1,3.95,6.24c.07.63.11,1.37.64,1.71a1.27,1.27,0,0,0,1.65-.49,3.67,3.67,0,0,0,.49-1.82c.26-2.91,1-7.39-2.43-8.73a23.26,23.26,0,0,0-3.92-.66C279.2,131.59,276.92,131,274.6,130.58Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.58,93.81c-.81.52-1.71,1.22-1.68,2.18a2,2,0,0,0,1.67,1.66,6.55,6.55,0,0,0,2.52-.22c5.61-1.18,12.12-.66,16.08,3.49a13.66,13.66,0,0,0,2.29,2.27c2.48,1.6,5.75,1.32,8.48,2a2.69,2.69,0,0,0-.4-1.62C243.45,93.81,229.4,87.54,219.58,93.81Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,195.78c-.61.11-1.32.38-1.46,1s.32,1.08.72,1.49l1.86,1.87a7.88,7.88,0,0,1,1.19,1.39c.81,1.32.8,3,1.12,4.48.1.46.34,1,.81,1.05a1,1,0,0,0,.7-.33c1.48-1.32,1.63-3.54,1.62-5.53C328.6,196.88,326.24,195,322,195.78Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.54,159.94a2.07,2.07,0,1,1-2.07-2.06A2.07,2.07,0,0,1,229.54,159.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.23,120.42a2.07,2.07,0,1,1-2.06-2.06A2.07,2.07,0,0,1,215.23,120.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,142.48a2.07,2.07,0,1,1-2.06-2.07A2.06,2.06,0,0,1,198.28,142.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.24,153.65a2.07,2.07,0,1,1-2.06-2.07A2.06,2.06,0,0,1,178.24,153.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.41,173.09a2.06,2.06,0,1,1-2.06-2.06A2.07,2.07,0,0,1,221.41,173.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.15,177.59a2.07,2.07,0,1,1-2.06-2.06A2.07,2.07,0,0,1,190.15,177.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.81,179a2.06,2.06,0,1,1-2.06-2.07A2.06,2.06,0,0,1,268.81,179Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.91,219.4a2.07,2.07,0,1,1-2.06-2.07A2.06,2.06,0,0,1,253.91,219.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.81,158a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,271.81,158Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67,116.3a2.07,2.07,0,1,1-2.06-2.06A2.07,2.07,0,0,1,271.67,116.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.38,143.91a2.07,2.07,0,1,1-2.06-2.07A2.06,2.06,0,0,1,309.38,143.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,174.33a2.07,2.07,0,1,1-2.06-2.07A2.06,2.06,0,0,1,315,174.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.83,94.28a2.07,2.07,0,1,1-2.07-2.07A2.07,2.07,0,0,1,246.83,94.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.3,125.5a2.06,2.06,0,1,1-2.06-2.06A2.07,2.07,0,0,1,248.3,125.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.96,
    cy: 190.43,
    r: 2.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,199.29a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,293.17,199.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.27,197.09A2.07,2.07,0,1,1,193.2,195,2.07,2.07,0,0,1,195.27,197.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.54,212a2.07,2.07,0,1,1-2.07-2.06A2.07,2.07,0,0,1,229.54,212Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,218.85a2.07,2.07,0,1,1-2.07-2.07A2.07,2.07,0,0,1,285.33,218.85Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-girl--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "344.99 324.18 333.38 324.98 332.98 325.51 342.93 345.1 353.98 343.26 344.99 324.18",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.99 324.18 333.38 324.98 332.98 325.51 342.93 345.1 353.98 343.26 344.99 324.18",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.38 323.65 333.38 324.98 343.33 344.57 354.38 342.74 345.38 323.65",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.31 325.51 335.24 326.63 343.54 342.66 352.81 341.12 345.31 325.51",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33,326.3l-.41-.8c-.23-.45-1.17-.73-2.09-.63l-1.78.18c-.93.1-1.5.53-1.27,1l.41.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,323.44a1,1,0,0,0-.94-.41l-.69.1a3.11,3.11,0,0,0-2.53-1.69c-1.63.06-.74,2-.74,2l-.73.11c-.4.06-.63.33-.51.6l.22.49,6.19-.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.84,324c-.58,0-.8.09-.45.77s.74,1.37.74,1.37l-2.73.31s-.5-1-.7-1.37-.49-.67-.92-.62l-.26-.33,4.34-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,326.41l-.41-.81A2.33,2.33,0,0,0,341,325l-1.77.19c-.93.09-1.5.53-1.27,1l.41.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.36,333.06s.31-1.78-.22-2.39-2.73-.53-3.81-1-1,.82-.43,1.24C346.14,331.81,348.6,332.23,349.36,333.06Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.67,309.69c1.78.09,3.42,1.41,5.23,5.9s5.53,14.33,4.93,16c-.41,1.16-13.72,4.64-13.72,4.64l-1.92-4.07,8.83-4-5-11.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.11,406.77a23.75,23.75,0,0,1,.63,2.3,6.24,6.24,0,0,1,.12,2.92c-.3.64-1.46,1.05-3.27,1a10.69,10.69,0,0,0-4.24,1.48,11.2,11.2,0,0,1-5.33.85c-1.61-.19-3.27-1.12-3.53-1.79s-.48-1.58,3.87-3c0,0,5.26-1.71,7.09-3.73Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.11,406.77a23.75,23.75,0,0,1,.63,2.3,6.24,6.24,0,0,1,.12,2.92c-.3.64-1.46,1.05-3.27,1a10.69,10.69,0,0,0-4.24,1.48,11.2,11.2,0,0,1-5.33.85c-1.61-.19-3.27-1.12-3.53-1.79s-.48-1.58,3.87-3c0,0,5.26-1.71,7.09-3.73Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.11,406.89l-.83-.1-3.83.08c-1.83,2-7.05,3.72-7.09,3.73l-.7.24c-.75.6-.11,1.64,1.69,1.8s7.38-1.72,8.62-2.32A3.69,3.69,0,0,0,356.11,406.89Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.11,405.25v1.64c0,.6-.7,1.49-2.53,1.43-1.28-.05-2.18-.4-2.13-1.45v-1.53Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.39,399.9c.33.13.4.77.41,2,0,.95.18,2.62-.95,2.92a3.48,3.48,0,0,1-3.44-.83c-.87-1.14-1.44-2.15-2.68-3.55-1.07-1.21-2.24-2.35-2.64-4-.36-1.51,0-2.16,1-2.57s2-.07,3.41,1.13a6.36,6.36,0,0,0,1.27.67C365.75,396,368.06,399.76,368.39,399.9Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.39,399.9c.33.13.4.77.41,2,0,.95.18,2.62-.95,2.92a3.48,3.48,0,0,1-3.44-.83c-.87-1.14-1.44-2.15-2.68-3.55-1.07-1.21-2.24-2.35-2.64-4-.36-1.51,0-2.16,1-2.57s2-.07,3.41,1.13a6.36,6.36,0,0,0,1.27.67C365.75,396,368.06,399.76,368.39,399.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.42,398.73l0,1.55s-1,2-3.91,0c-.06-.16-.32-3.15-.32-3.15Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.8,395.67a6.36,6.36,0,0,1-1.27-.67h0c-1.16-.37-3.6.06-2.5,1.74a13.21,13.21,0,0,0,3.44,3.54c1.3.64,1.76-.16,1.76-.16l-.46-3.62A2.92,2.92,0,0,0,364.8,395.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.52,377.34a36.59,36.59,0,0,0-1.67-8s1-6.82,1.74-13.37c1.8-15.37.6-15.62-1.57-21,0,0-19.71-2.54-20.53,5.66-1,10.2-.56,30-.39,33.61s.47,5.26,1.54,12.84c.82,5.77,1.59,18.39,1.59,18.39a5,5,0,0,0,5.07-.26s2.47-15.52,2.41-19.69a35.72,35.72,0,0,0-1.33-9.14s1.67-16.63,2.1-19.28c0,0,.48,5.31.65,8.93s1.15,7.1,2,13.83c.75,5.85,2,18.05,2,18.05,2.59,1.49,4.39.81,4.39.81S371.09,382.41,370.52,377.34Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.48,357.14l1.08-6.85a15.2,15.2,0,0,0,6.08-2.12,8.14,8.14,0,0,1-4.88,2.86l-1.1,8-.44,8.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.48 305.84 357.21 313.5 363.94 313.07 363.4 304.58 356.48 305.84",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,312.41c-.68-2-2.08-3.21-5.16-3.25l-1.13,0c-.22,1.13-3.53,2-6.81.89-.46.11-1.72.35-2.44.44l-1.56.23c-2.39.78-3.44,4.92-3.67,11.49s-1.21,20.6-1.21,20.6,5.13,2.75,13.22,1.68a16.14,16.14,0,0,0,9.81-4.68,50.31,50.31,0,0,0-3.74-10.52C371.1,320,371,315.42,370,312.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.21,344.78a28.83,28.83,0,0,0,4-.25,15.69,15.69,0,0,0,9.8-4.72,50.64,50.64,0,0,0-3.73-10.48,43.23,43.23,0,0,0,3.16-10.93c-.31,2-3.21,9.57-7,11.85a6.79,6.79,0,0,1,4,2.85C369.25,335.62,367.74,344.24,357.21,344.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,296.33s-2.55-3-.55-6c2.35-3.48,6.48-4.66,11.59-3.14,2.54.75,6.25,4.25,6.44,9.16.15,3.78-10.46,6.28-10.29,8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.49,297.44s-1.49,2.25-1.29,2.49a3.46,3.46,0,0,0,1.14.49Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.05,290.3c-1.45.75-4,2.13-4.6,7.47s.56,7.38,1.31,8.09c.5.49,3.1.66,4.46.24,1.69-.52,5.37-2.34,7.1-5.17,2-3.32,2.44-7.76.1-9.49A8.74,8.74,0,0,0,356.05,290.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.62,290.53s-1.26,5,.25,8.15c0,0,.88-1.95,2.56-1.39s1.53,2.81.2,4a2.51,2.51,0,0,1-2.61.56,4.55,4.55,0,0,0,2.41,3.86s4.94,2.36,9.4-2.41c4.05-4.33,3.53-12.09-2.44-14.08A10.26,10.26,0,0,0,355.62,290.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.77,290.77a5.26,5.26,0,1,1-5.26-5.26A5.26,5.26,0,0,1,373.77,290.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77,288.28c-2.22,2.26-2.35,8.8,4.1,10.4l4.21-11.56C357.63,285.52,353.76,286.26,351.77,288.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.22,300.47a1.27,1.27,0,1,1,.86-2.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,310.69s-1.05-.15-5,.91-13.26,3.19-13.26,3.19-10.93-5.27-11.41-5.84-.21-1.73-.08-2.37.35-2.06.49-2.46c.25-.69-.78-.5-1.38.15s-.88,1.92-1.18,2.14-2.6-2.43-3.72-3.71-1.64-2.17-2.39-1.64c-.54.38-.19,1.13.61,2.23a11.84,11.84,0,0,1,1,1.45c.1.19-.2.35-.31.46s-.61.51-.63.81a4.07,4.07,0,0,1,0,.5c-.11.36-.56.53-.69.89s0,.54,0,.81-.13.33-.16.51a1.23,1.23,0,0,0,.36.94,9.14,9.14,0,0,0,2.88,1.86c.86.47,1.74.67,2.73,1.11s12.38,8.56,14.43,8.38c2.32-.2,16.47-2.73,16.47-2.73C355.8,315.75,353.37,310.69,353.37,310.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,309.16a7.52,7.52,0,0,1,3.34.59c1.57.74,2.53,2.49,2.61,6.38s-3,13.42-3,13.42,3.28,7.74,3.89,11.14-.23,13.53-.23,13.53-6.44,5.27-19.26,3c-.26-.05-.47-12.05-.73-12.1s-.5,11.86-.73,11.81q-1.82-.39-3.78-1s.27-10,.31-14.32.35-20.76,1.79-25a16.82,16.82,0,0,1,3.43-6.2h2.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,310.44c-5.63-.42-12.75,2.69-19.27,4.35l-9-4.47s-2.82,3-1.19,5.18c0,0,8.35,6,10.34,6.4s16.7-2.59,16.7-2.59a5.44,5.44,0,0,0,3.29-4.54C355.66,311.22,354.38,310.44,354.38,310.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.7,308.09a.76.76,0,0,0-.62.44c-.23.44-.85,1.88-.85,1.88s1.54,2,5.17,1.55,4.42-2.8,4.42-2.8-.37-2.08-1.26-2v.4s-.34.8-2.5,1.08C358,309,356.7,308.09,356.7,308.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.48,330.15s6.33,1.59,10.19-.7c.59.53.55,1.13,0,2.14,0,0-3.78,2.24-10.16.61A1.57,1.57,0,0,1,356.48,330.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,331.3a.57.57,0,1,1-.57-.56A.56.56,0,0,1,357.65,331.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.72,330.74a.56.56,0,0,1-.56.56.57.57,0,0,1-.57-.56.58.58,0,0,1,.57-.57A.57.57,0,0,1,366.72,330.74Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.62,391c-.32.13-.39.76-.41,2,0,.94-.18,2.59.92,2.89a3.45,3.45,0,0,0,3.41-.8,42.4,42.4,0,0,1,2.66-3.49,9.69,9.69,0,0,0,2.62-4c.36-1.49,0-2.13-1-2.54-1.4-.56-3.54,1.43-4.63,1.76C128.25,387.15,126,390.89,125.62,391Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59,391c-.32.13-.39.76-.42,2,0,.94-.18,2.59.93,2.89a3.47,3.47,0,0,0,3.41-.8,42.62,42.62,0,0,1,2.65-3.49,9.61,9.61,0,0,0,2.63-4c.36-1.49,0-2.13-1-2.54-1.4-.56-3.55,1.43-4.63,1.76S125.92,390.91,125.59,391Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,389.87l0,1.53a3.74,3.74,0,0,0,3.86,0c.06-.15.35-2.19.35-2.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.18,399.53a25.63,25.63,0,0,0-.62,2.51,6.66,6.66,0,0,0-.06,3.16c.34.68,1.61,1.1,3.56,1.05a11.49,11.49,0,0,1,4.62,1.49,12,12,0,0,0,5.79.79c1.73-.24,3.51-1.29,3.78-2s-.13-1.46-4.26-3.12c0,0-5.74-1.72-7.77-3.87Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.18,399.53a25.63,25.63,0,0,0-.62,2.51,6.66,6.66,0,0,0-.06,3.16c.34.68,1.61,1.1,3.56,1.05a11.49,11.49,0,0,1,4.62,1.49,12,12,0,0,0,5.79.79c1.73-.24,3.51-1.29,3.78-2s-.13-1.46-4.26-3.12c0,0-5.74-1.72-7.77-3.87Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.14,397.89s0,1.13,0,1.77.79,1.6,2.77,1.48c1.39-.08,2.35-.47,2.27-1.62l0-1.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.15,369.64c.58-5,.89-8.09.89-8.09s-.72-6-1.12-12.52c-.45-7-.36-15.35.23-18.31,0,0,22.55-5.09,23.14,3s-.25,28.79-.44,32.36-.73,6.74-1.33,12.54-2.34,19.23-2.34,19.23a5.35,5.35,0,0,1-5,0s-2-16.2-1.89-20.32a35.58,35.58,0,0,1,1.36-9s-.58-6.68-1.09-12.5-1-8.6-1.12-11.13l-.49-.23s-.27,10.06-.46,13.63-.68,7-1.56,13.65c-.77,5.76-3.16,18-3.16,18-2.55,1.46-4.13-.09-4.13-.09S123.56,374.64,124.15,369.64Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.4,344.93s-5.56-2.58-8.36-5a18.14,18.14,0,0,0,6,5.06s1.48,12.45,1.46,12.2l.42-12.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.25 298.66 138.08 306.07 131.4 305.73 132.18 297.07 139.25 298.66",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,301.51s-4.64-1.19-6.62,2.13-.14,10.5-.14,10.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.53,306.07c.61-2,3.93-5,6.49-4.56l1.74.29c.3,1.25,3.5,2.21,6.77,1.44,1,.26,1.89.53,2.71.8,2.35.78,4.52,2.75,4.88,10.41,0,0,2.08,22.71,2.1,34.15a21.9,21.9,0,0,1-4.16,1.26c-.15,0-.75-13.91-.9-13.88s0,14-.22,14.08a37.77,37.77,0,0,1-11,0,21.77,21.77,0,0,1-9.1-3.44s0-14.62,1-21.84c-.47-4.94-.57-8.23-.79-10C122.48,309.91,123.11,307.46,123.53,306.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.16,326.89s-6.49.59-10-2.27c-.66.43-.71,1-.3,2.11,0,0,3.4,2.8,9.95,2.18A1.55,1.55,0,0,0,135.16,326.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.83,327.85a.57.57,0,1,0,.65-.48A.58.58,0,0,0,133.83,327.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,325.88a.58.58,0,0,0,.48.65.56.56,0,0,0,.64-.47.57.57,0,1,0-1.12-.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.9,300.91s.32-.09.55.35a16.54,16.54,0,0,1,.62,2.42s-1.41,1.61-5,1.17-4.43-3.09-4.43-3.09.46-2.14,1.34-2.05l-.06.75s.34.8,2.5,1.08C137.42,301.93,138.9,300.91,138.9,300.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.39 293.15 174.29 300.4 167.38 319.3 154.4 312.03 160.39 293.15",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.39 293.15 174.29 300.4 167.38 319.3 154.4 312.03 160.39 293.15",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.79 292.85 173.7 300.1 166.79 319 153.81 311.73 159.79 292.85",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.59 294.75 172.26 300.84 166.14 317.08 155.25 310.99 160.59 294.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,296.75l.22-.58c.13-.32,1.1-.13,2.17.43l2.05,1.06c1.08.55,1.85,1.26,1.72,1.58l-.22.58Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71,294.44c.08-.2.5-.17.94.07l.81.43s.49-1.24,2.34-.38,1.43,2.31,1.43,2.31l.86.47c.47.26.8.64.75.84l-.11.37-7.16-3.74S163.63,294.64,163.71,294.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.48,295.28c.67.32.93.48.74,1s-.42,1-.42,1l3.17,1.66s.26-.72.38-1,.34-.41.85-.15l.19-.2-5-2.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.35,296.78l.22-.58c.13-.32,1.1-.13,2.17.43l2.06,1.06c1.07.55,1.84,1.26,1.72,1.58l-.23.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.63,304.2c2.66.8,4.28.94,7.22,5.46s9.59,13,10.23,14.08a5.76,5.76,0,0,1,.29,5.16c-.72,1.28-2.44.53-5.36-2s-8.77-9.28-8.77-9.28A48.2,48.2,0,0,1,141.63,304.2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,329.53c2.46-.3,7.77-7.74,9.41-10.29a18.11,18.11,0,0,1,5-5.25c2.6-1.93,2.22-4.88,1.09-7.59-.4-.94-1.73-.33-1.73-.33l-.47,1.29-.82,2.22c-.55.51-.86.68-.9.53s.41-1.49.4-2.73c0-1.51-1.07-.52-1.38,0a17.6,17.6,0,0,0-1.11,2.48c-.53,1.34-.31,2.7-.95,3.62s-9.21,9.13-9.21,9.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,304a13.92,13.92,0,0,1,4,1.3c2.11,1.07,2.81,2.88,5.87,6.84s7,9.39,7,9.39l7.13-6.27a4.12,4.12,0,0,0,3.26,3,44.09,44.09,0,0,1-6.17,9.15c-3.53,3.79-3.55,3.6-6.77,1.71s-10.62-11-10.62-11S137.59,312.36,141.24,304Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19,289.57s1.75,2.66,1.55,2.92-1.48.49-1.48.49Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.29,289.19a2.09,2.09,0,1,1,2.08,2.09A2.09,2.09,0,0,1,141.29,289.19Zm.46,0a1.63,1.63,0,1,0,1.62-1.62A1.62,1.62,0,0,0,141.75,289.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.33,282.22c3.54.75,4.57,2.31,4.9,7.93.35,5.89-.25,7.73-1,8.53-.52.53-3.42.63-4.88.22-1.83-.5-6-2-7.91-4.92-2.28-3.49-2.87-8.2-.43-10.14C133.42,281.12,137.89,281.92,139.33,282.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.26 288.75 138.97 289.57 139.22 290.01 145.26 289.23 145.26 288.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.62,284.06l-.1.1c-.69.65-1.56,1.06-2.27,1.67a5.28,5.28,0,0,0-1.61,2.57c-.24.81-.33,1.78-1.21,2.16,0,0-.56-2.18-2.4-1.91s-2.09,2.63-.93,4.06,2.25.88,2.25.88-.06,3.11-1.43,4.87a9.51,9.51,0,0,1-4.45-.11c-1.77-.38-4.28-2.59-5.33-4.94-2.23-5-2.38-9.42.78-10.76.34-2.28,2.14-3.31,4.19-3.78,3.07-.7,5.94,1.12,9,.44.64-.14,1.26-.37,1.9-.45a.32.32,0,0,1,.22,0c.16.08.15.3.1.46a3.92,3.92,0,0,1-.89,1.64,9.55,9.55,0,0,0,3.44-.43A4.43,4.43,0,0,1,144.62,284.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,283.42l-2.12-1.25a1.23,1.23,0,1,1,2.12,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47,291.8l-.07-2.47a1.24,1.24,0,0,1,.07,2.47Z",
    style: {
      fill: "#263238"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdAi);
export default __webpack_public_path__ + "static/media/prod-ai.02cedf67d2a3dfe2aec9c4cdb68945f6.svg";
export { ForwardRef as ReactComponent };